import React, { useEffect, useRef, useState } from "react";
import { Transition } from "@headlessui/react";
import Pencil from "components/Icon/Pencil";
import classNames from "classnames";
import { Auth, Storage } from "aws-amplify";
import API from "../api/api.main";
import Swal from "sweetalert2";
import { S3Image } from "aws-amplify-react";
import { checkRole } from "utils/role";
import { useSelector } from "react-redux";
import { EmitterStatus } from "event";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { format } from "date-fns";
import _ from "lodash";
import Cancel from "components/Icon/Cancel";
import Check from "components/Icon/Check";
import Select from "react-select";
import axios from "axios";
import { ExportContactBook } from "components/LoanRequest/LoanRequestTableBackEnd";
import numeral from "numeral";
import {
  BANK_OPTIONS,
  DEBT_OPTIONS,
  provinces,
} from "../constrant/leasing.ct.options";
import ThaiAddress from "react-thai-address";
import LoadingPage from "../../Loading/LoadingPage";
import { DatePicker } from "antd";
import moment from "moment";
import {
  calculatePayPerMonth,
  calculatePayPerMonthPerYear,
  getFeeDropDown,
  getInformationTF,
  getInterestReduction,
  getRequestAmountAfter,
  getStatments,
  getStyleStatus,
  getTotalInterestNoVat,
  round,
  roundUp,
} from "../utils/leasing.u";
import LoadingMutation from "../../Loading/LoadingMutation";
import HistoriesModalTable from "./leasing.f.historyModalTable";
import { IMaskInput } from "react-imask";
import StringMask from "string-mask";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

const baseApiDopa = "https://dopa-api-public.moneyhubservice.com";

const FEE_OPTIONS = [
  {
    label: "เรียกเก็บ",
    value: "เรียกเก็บ",
  },
  {
    label: "ฟรีค่าธรรมเนียม",
    value: "ฟรีค่าธรรมเนียม",
  },
];

const CAREER_OPTIONS = [
  "อาชีพ",
  "พนักงานเอกชน",
  "ข้าราชการ/รัฐวิสาหกิจ",
  "ลูกจ้าง",
  "คนขับแท๊กซี่/มอเตอร์ไซค์รับจ้าง ",
  "อาชีพอิสระ/ฟรีแลนซ์ ",
  "เจ้าของกิจการ",
  "ค้าขาย",
];

const POSITION_OPTIONS = [
  {
    label: "พนักงานทั่วไป",
    value: "พนักงานทั่วไป",
  },
  {
    label: "ระดับอาวุโส",
    value: "ระดับอาวุโส",
  },
  {
    label: "ระดับผู้จัดการหรือสูงกว่า",
    value: "ระดับผู้จัดการหรือสูงกว่า",
  },
  {
    label: "ไม่สามารถระบุตำแหน่งงาน",
    value: "ไม่สามารถระบุตำแหน่งงาน",
  },
];

const GURANTOR_OPTIONS = [
  {
    label: "ไม่มีผู้ค้ำประกัน",
    value: "ไม่มีผู้ค้ำประกัน",
  },
  {
    label: "มีผู้ค้ำประกัน",
    value: "มีผู้ค้ำประกัน",
  },
];

const ContentImage = ({ value }) => {
  const handleApprove = useFullScreenHandle();

  if (!value) return <div className="w-full h-full mx-auto"></div>;

  return (
    <FullScreen className="w-full h-full" handle={handleApprove}>
      <S3Image
        onClick={handleApprove.enter}
        imgKey={value}
        className="object-fill mx-auto"
        contentType="image/jpeg"
        // style={{ width: "600px", height: "500px" }}
      />
    </FullScreen>
  );
};

const PathOptimized = ({ degree, index, item, rotate, canRotate }) => {
  return (
    <div>
      <S3Image
        preview="true"
        imgKey={item}
        className={"w-full"}
        style={{ transform: "rotate(" + degree[index] + "deg)" }}
      />
      {/* <img
        src={`${item}`}
        style={{ transform: "rotate(" + degree[index] + "deg)" }}
      /> */}
      {canRotate ||
        (false && (
          <div className="flex px-4 my-2 flex-row justify-between w-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => rotate(index, -90)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => rotate(index, 90)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </div>
        ))}
    </div>
  );
};

const Gallery = ({ paths, canRotate = false, max = "grid-cols-4 " }) => {
  const [degree, setDegree] = useState([]);

  useEffect(() => {
    setDegree(Array(20).fill(0));
  }, []);

  const rotate = (index, change = 0) => {
    let temp = [...degree];
    temp[index] = temp[index] + change;
    if (temp[index] < 0) temp[index] = 270;
    if (temp[index] >= 360) temp[index] = 0;
    // alert("หมุนไปที่ " +temp[index] + " องศา")
    setDegree(temp);
  };

  if (paths?.length == undefined || paths?.length < 1) return <div></div>;

  return (
    <div className={"grid grid-cols-1 md:grid-cols-2  gap-4 lg:" + max}>
      {paths?.length &&
        paths?.map((item, index) => {
          return (
            <PathOptimized
              item={item}
              index={index}
              rotate={rotate}
              canRotate={canRotate}
              degree={degree}
            />
          );
        })}
    </div>
  );
};

const ContentFilePdf = ({ title, value, display = false }) => {
  const getPathUrl = () => {
    if (String(value).startsWith("fakepath")) {
      return URL.createObjectURL(value);
    }
    return value;
  };

  if (value) {
    return (
      <div className="text-blue-700">
        {display ? (
          <div className="w-full h-auto">{value}</div>
        ) : (
          <a target="_blank" href={`${value}`} className="w-full h-auto">
            {title}
          </a>
        )}
      </div>
    );
  }

  return <div className="text-gray-700">ไม่มีไฟล์{title}</div>;
};

function tryParseJSON(jsonString) {
  try {
    var o = JSON.parse(jsonString);
    if (o && typeof o === "object") {
      return o;
    }
  } catch (e) {}

  return jsonString.length ? jsonString : false;
}

const Input = ({ ...rest }) => {
  return (
    <input
      type="text"
      {...rest}
      className="px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
    />
  );
};

const Debt = ({ debt, onChangeEditDebt, onClickDeleteDebt }) => {
  return (
    <div>
      {debt?.length > 0 &&
        debt.map((data, index) => {
          return (
            <div
              key={index}
              className="border border-gray-200 bg-white p-4 relative"
            >
              <div className=" absolute right-0">
                <button
                  onClick={() => onClickDeleteDebt(index)}
                  className="bg-red-500 text-white px-2 py-1 rounded text-xs mr-2"
                >
                  ลบ
                </button>
              </div>
              <div className="flex">
                <div> ประเภท </div>
                <Select
                  styles={customStyles()}
                  className={classNames(" ml-2 w-40")}
                  options={DEBT_OPTIONS}
                  value={{ label: data.type, value: data.type }}
                  onChange={(value) =>
                    onChangeEditDebt("type", value?.value, index)
                  }
                />
                {/* <span className="text-gray-700 font-bold">{data.type}</span> */}
              </div>
              <div className="flex flex-col mt-1 mb-3">
                <div className="flex items-center">
                  {" "}
                  <div>จำนวน </div>
                  <input
                    className={classNames(
                      "ml-2 px-2 py-1 mr-auto bg-transparent text-gray-600 relative border-b border-blue-400 text-sm outline-none bg-white focus:outline-none focus:border-blue-700 focus:ring-0 ring-0"
                    )}
                    value={data.amount}
                    onChange={(e) =>
                      onChangeEditDebt("amount", e.target.value, index)
                    }
                    name={"amount"}
                    type={"number"}
                  />
                </div>
                {String(data.amount).length === 0 && (
                  <span
                    id={`required_debt_${index}`}
                    className="text-red-500 text-xs ml-12 mt-1"
                  >
                    โปรดกรอกข้อมูล
                  </span>
                )}
              </div>
              <div className="flex flex-col mt-1">
                <div className="flex items-center">
                  <div>ผ่อนต่อเดือน</div>
                  <input
                    className={classNames(
                      "ml-2 px-2 py-1 mr-auto bg-transparent text-gray-600 relative border-b border-blue-400 text-sm outline-none bg-white focus:outline-none focus:border-blue-700 focus:ring-0 ring-0"
                    )}
                    value={data.payperinsallment}
                    onChange={(e) =>
                      onChangeEditDebt(
                        "payperinsallment",
                        e.target.value,
                        index
                      )
                    }
                    name={"payperinsallment"}
                    type={"number"}
                  />
                </div>
                {String(data.payperinsallment).length === 0 && (
                  <span
                    id={`required_debt_${index}`}
                    className="text-red-500 text-xs ml-20 mt-1"
                  >
                    โปรดกรอกข้อมูล
                  </span>
                )}
                {/* <span className="text-gray-700 font-bold">
                  {Number(data.amount).toLocaleString()}
                </span> */}
              </div>
              {/* <div>
                ผ่อนต่อเดือน{" "}
                <span className="text-gray-700 font-bold">
                  {Number(Math.ceil(data.payperinsallment)).toLocaleString()}
                </span>
              </div> */}
            </div>
          );
        })}
    </div>
  );
};

const Content = ({
  title,
  value,
  textColor = "text-gray-700",
  showEdit = false,
  isEdit = false,
  onClickEdit = () => {},
  loadingCheck,
  onClickCheck,
}) => {
  const onClick = () => {
    if (onClickEdit) {
      onClickEdit();
    }
  };

  return (
    <div className={"text-gray-700 flex"}>
      {title}
      <span className={textColor + " font-bold break-all	"}>&nbsp;{value}</span>
      {title === "บัตรประชาชน" && (
        <button
          disabled={loadingCheck}
          onClick={onClickCheck}
          className={classNames("ml-2 px-2 rounded text-sm", {
            "cursor-not-allowed bg-gray-400": loadingCheck,
            "bg-red-500 text-white cursor-pointer": !loadingCheck,
          })}
        >
          {loadingCheck ? "กำลังตรวจสอบ" : "ตรวจสอบ"}
        </button>
      )}
      {showEdit && (
        <div className=" px-2" onClick={onClick}>
          <div className="text-blue-500 flex items-center space-x-1 cursor-pointer">
            <Pencil className="w-4 h-4" />
            <div>Edit</div>
          </div>
        </div>
      )}
    </div>
  );
};

const getJobAge = (jobAge) => {
  const mounthCount = jobAge % 12;
  if (jobAge > 12) {
    return `${Math.floor(jobAge / 12)} ปี ${mounthCount} เดือน`;
  }

  return `${jobAge} เดือน`;
};

const Title = ({ title }) => {
  return <h3 className="mb-4 text-blueGray-800 font-black">{title}</h3>;
};

const BoxContent = ({ children, className }) => {
  return (
    <div className={classNames("p-4 bg-gray-50", className)}>{children}</div>
  );
};

const HeaderModal = ({
  leasing_request,
  form,
  onClickHistory,
  loadingHistories,
}) => {
  return (
    <div className="flex items-center justify-between">
      <h3
        className="text-lg leading-6 font-medium text-gray-900 flex"
        id="modal-title"
      >
        <div>{leasing_request?.contract_id} /&nbsp;</div>
        <div>
          {leasing_request.request_id} {"  /  "}
        </div>
        <span
          className={classNames(" ml-1", getStyleStatus(form?.loan_status))}
        >
          {form.loan_status}
        </span>
        {form?.isWarning && (
          <span className="text-yellow-500 ml-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </span>
        )}
        {form?.oldcustomer === "true" && (
          <span className="ml-8 flex text-green-500 ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            เป็นลูกค้าเก่าที่ปิดสัญญาแล้ว
          </span>
        )}
      </h3>
      <div className="flex items-center">
        <button
          onClick={onClickHistory}
          className={classNames(
            " text-white px-4 py-2 rounded flex items-center",
            {
              "bg-gray-400 cursor-not-allowed": loadingHistories,
              "bg-blue-500 hover:bg-blue-600 active:bg-blue-700  transition-all":
                !loadingHistories,
            }
          )}
        >
          {loadingHistories && (
            <svg
              className={classNames(
                "animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              )}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}{" "}
          ประวัติ
        </button>
      </div>
    </div>
  );
};

const getDefaultPayDate = (days = 1) => {
  let result = new Date();
  // result.setDate(result.getDate() + 1);
  return result;
};

// MARK DATE
const DateInput = ({
  label,
  value = "",
  defaultValue,
  onChange,
  name,
  type = "text",
  width = "w-48",
  required = false,
  customenRequired = false,
  errorMessage = "โปรดกรอกข้อมูล",
  ...rest
}) => {
  return (
    <div className="flex items-center w-full my-1">
      <div className={"text-gray-700"}>{label}</div>
      <div className="flex items-center flex-col ml-2">
        <DatePicker
          allowClear={false}
          name={name}
          format={"DD-MM-YYYY"}
          value={value ? moment(value) : ""}
          onChange={onChange(name)}
          defaultPickerValue={
            value ? moment(new Date(value)) : moment(new Date())
          }
        />
        {!value && required && (
          <div className="text-red-500 text-xs mr-auto ml-2 mt-1">
            {errorMessage}
          </div>
        )}
        {customenRequired && (
          <div
            id={`required_${name}`}
            className="text-red-500 text-xs mr-auto ml-2 mt-1"
          >
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

// MARK INPUT
const TextInput = ({
  label,
  label2,
  value,
  onChangeForm,
  name,
  type = "text",
  width = "w-48",
  required,
  errorMessage = "โปรดกรอกข้อมูล",
  customenRequired,
  className = "",
  ...rest
}) => {
  return (
    <div className="flex items-center w-full my-1">
      <div className="flex items-center flex-col">
        <div className={"text-gray-700"}>{label}</div>
        <div className={"text-gray-700"}>{label2}</div>
      </div>
      <div className="flex items-center flex-col">
        <input
          className={classNames(
            "ml-2 px-2 py-1 mr-auto bg-transparent  relative border-b border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-700 focus:ring-0 ring-0",
            width,
            className
          )}
          value={value}
          onChange={onChangeForm}
          name={name}
          type={type}
          {...rest}
        />
        {!value && required && !customenRequired && (
          <div
            id={`required_${name}`}
            className="text-red-500 text-xs mr-auto ml-2 mt-1"
          >
            {errorMessage}
          </div>
        )}
        {customenRequired && (
          <div
            id={`required_${name}`}
            className="text-red-500 text-xs mr-auto ml-2 mt-1"
          >
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

const customStyles = () => {
  return {
    container: (provided) => ({
      ...provided,
      display: "inline-block",
      minHeight: "1px",
      textAlign: "left",
      border: "none",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "1px",
      height: "28px",
    }),
    input: (provided) => ({
      ...provided,
      minHeight: "1px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      minHeight: "1px",
      paddingTop: "0",
      paddingBottom: "1px",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      minHeight: "1px",
      height: "10px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      minHeight: "1px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      minHeight: "1px",
      height: "28px",
      paddingTop: "0",
      paddingBottom: "0",
    }),
    singleValue: (provided) => ({
      ...provided,
      minHeight: "1px",
      paddingBottom: "2px",
    }),
  };
};

// MARK SELECT
const SelectInput = ({
  value,
  onChangeSelect,
  name,
  options = [],
  label,
  width = "w-40",
  required,
  errorMessage = "โปรดเลือกข้อมูล",
}) => {
  return (
    <div className="flex items-center w-full my-1">
      <div className={"text-gray-700"}>{label}</div>
      <Select
        styles={customStyles()}
        className={classNames(" ml-2", width)}
        options={options}
        value={value}
        onChange={onChangeSelect(name)}
      />
      {!value?.value && required && (
        <div
          id={`required_${name}`}
          className="text-red-500 text-xs mr-auto ml-2 mt-1"
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

const UploadFile = ({
  options,
  multiple = false,
  label = "อัพโหลดไฟล์",
  className,
  name,
  onChange,
}) => {
  const onClickUploadFile = () => {
    try {
      const createElment = document.createElement("input");
      createElment.onchange = onChange;
      createElment.type = "file";
      createElment.name = name;
      createElment.multiple = multiple;
      createElment.click();
    } catch (error) {
      alert(error);
    }
  };

  return (
    <button
      className={classNames(
        "bg-blue-500 text-white px-2 py-1 rounded text-xs cursor-pointer",
        className
      )}
      onClick={onClickUploadFile}
    >
      {label}
    </button>
  );
};

const getProvince = (address) => {
  if (address) {
    const province = address.split(",")[2];
    return province;
  }
  return "";
};

const getDistrict = (address) => {
  if (address) {
    const district = address.split(",")[1];
    return district;
  }
  return "";
};

const getSubDistrict = (address) => {
  if (address) {
    const district = address.split(",")[0];
    return district;
  }
  return "";
};

const getZipCode = (address) => {
  if (address) {
    const zipcode = address.split(",")[3];
    return zipcode;
  }
  return "";
};

const SetDate = (date) => {
  if (date) {
    if (date?.search("-") > -1) {
      return date;
    }
    const [day, month, year] = date?.split("/");
    return `${+year - 543}-${month}-${day}`;
  }
  return "";
};

const SetLtv = (ltv, grade) => {
  if (!_.isNaN(Number(ltv)) && grade) {
    return `Grade ${grade} (${ltv})`;
  } else if (isNaN(Number(ltv)) && ltv?.length > 0) {
    return ltv;
  }
  return "";
};

function FootageRequestModal({
  leasing_request,
  openModal,
  setOpenModal,
  refetch,
  query,
  isTransfer,
  prevForm,
  setPrevForm,
}) {
  const getConvertRequest = (local_leasing_request = leasing_request) => {
    return {
      ...local_leasing_request,
      attachments: [],
      attachmentViews: [],
      transferDate: getDefaultPayDate(),
      addressProvince: getProvince(local_leasing_request?.address),
      addressDistrict: getDistrict(local_leasing_request?.address),
      addressSubDistrict: getSubDistrict(local_leasing_request?.address),
      currentAddressProvince: getProvince(
        local_leasing_request?.currentAddress
      ),
      currentAddressDistrict: getDistrict(
        local_leasing_request?.currentAddress
      ),
      currentAddressSubDistrict: getSubDistrict(
        local_leasing_request?.currentAddress
      ),
      addressSubDistrictZipCode: getZipCode(local_leasing_request?.address),
      currentAddressSubDistrictZipCode: getZipCode(
        local_leasing_request?.currentAddress
      ),
      addressProvinceGrt: getProvince(local_leasing_request?.addressGrt),
      addressDistrictGrt: getDistrict(local_leasing_request?.addressGrt),
      addressSubDistrictGrt: getSubDistrict(local_leasing_request?.addressGrt),
      currentAddressProvinceGrt: getProvince(
        local_leasing_request?.currentAddressGrt
      ),
      currentAddressDistrictGrt: getDistrict(
        local_leasing_request?.currentAddressGrt
      ),
      currentAddressSubDistrictGrt: getSubDistrict(
        local_leasing_request?.currentAddressGrt
      ),
      birthdateThGrt: SetDate(local_leasing_request?.birthdateThGrt),
      citizenexpiredateGrt: SetDate(
        local_leasing_request?.citizenexpiredateGrt
      ),
      addressSubDistrictGrtZipCode: getZipCode(
        local_leasing_request?.addressGrt
      ),
      currentAddressSubDistrictGrtZipCode: getZipCode(
        local_leasing_request?.currentAddressGrt
      ),
      birthdateTh: SetDate(local_leasing_request?.birthdateTh),
      citizenexpiredate: SetDate(local_leasing_request?.citizenexpiredate),
      birthdateThGrt: SetDate(local_leasing_request?.birthdateThGrt),
      citizenexpiredateGrt: SetDate(
        local_leasing_request?.citizenexpiredateGrt
      ),
      beginjobdate: SetDate(local_leasing_request?.beginjobdate),
      ltv: SetLtv(local_leasing_request?.ltv, local_leasing_request?.grade_ltv),
      mockConfirmDate:
        local_leasing_request?.mockConfirmDate !== "-"
          ? local_leasing_request?.mockConfirmDate
          : "-",
    };
  };

  const {
    user,
    group,
    interest,
    switch_val,
    feeTransfer,
    feeInspection,
    feeService,
    // ...rest
  } = useSelector((state) => state.initializeApp);

  const [openHistory, setOpenHistory] = useState(false);
  const [histories, setHistories] = useState([]);
  const [form, setForm] = useState(null);
  const [loadingSaveAttchment, setLoadingSaveAttachment] = useState(false);
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [oriAttachments, setOriAttachments] = useState([]);
  const [error, setError] = useState(null);
  const [oriAttachmentLoan, setOriAttachmentLoan] = useState([]);
  const [loadingAmount, setLoadingAmount] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingRemark, setLoadingRemark] = useState(false);
  const [status, setStatus] = useState("");
  const [isEditAmount, setIsEditAmount] = useState(false);
  const [isEditPeriod, setIsEditPeriod] = useState(false);
  const [isEditEmail, setIsEditEmail] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingPeriod, setLoadingPeriod] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [district, setDistrict] = useState([]);
  const [subDistrict, setSubDistrict] = useState([]);
  const [currentDistrict, setCurrentDistrict] = useState([]);
  const [currentSubDistrict, setCurrentSubDistrict] = useState([]);
  const [districtGrt, setDistrictGrt] = useState([]);
  const [subDistrictGrt, setSubDistrictGrt] = useState([]);
  const [currentDistrictGrt, setCurrentDistrictGrt] = useState([]);
  const [currentSubDistrictGrt, setCurrentSubDistrictGrt] = useState([]);
  const [loadingId, setLoadingId] = useState(false);
  const [ltvGroups, setLtvGroups] = useState([]);
  const [fcr, setFcr] = useState({});
  const [openModalHistories, setOpenModalHistories] = useState(false);
  const [loadingHistories, setLoadingHistories] = useState(false);
  const [loadingRelationOne, setLoadingRelationOne] = useState(false);
  const [loadingRelationTwo, setLoadingRelationTwo] = useState(false);
  const [loadingSaveGrt, setLoadingSaveGrt] = useState(false);
  const [loadingDebtSave, setLoadingDebtSave] = useState(false);
  const [loadingPersonalSave, setLoadingPersonalSave] = useState(false);
  const [loadingInformation, setLoadingInformation] = useState(false);
  const [loadingCar, setLoadingCar] = useState(false);
  const [loadingBank, setLoadingBank] = useState(false);
  const [yearOptions, setYearOptions] = useState([]);
  const [temp, setTemp] = useState({});
  const [checkClickSubmit, setCheckClickSubmit] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const fileRef = useRef();

  useEffect(() => {
    setForm((prev) => {
      if (prevForm) {
        return { ...prevForm };
      }
      return {
        ...getConvertRequest(),
      };
    });
    setFirstLoad(false);
  }, []);

  useEffect(() => {
    setPrevForm(form);
  }, [form]);

  useEffect(() => {
    if (leasing_request && openModal && !firstLoad) {
      queryAttachment();
      queryFCR();
      // queryAttachmentLoan();
      SetDistrict("addressProvince", form);
      SetDistrict("addressDistrict", form);
      SetDistrict("currentAddressProvince", form);
      SetDistrict("currentAddressDistrict", form);
      SetDistrict("addressProvinceGrt", form);
      SetDistrict("currentAddressProvinceGrt", form);
      findGroupByYearForNTF();
      setTemp(form);
      fetchYears();
      setForm({
        ...form,
        fee_service: feeService,
        fee_inspection: feeInspection,
        fee_transfer: feeTransfer,
      });
    }
  }, [leasing_request, openModal, firstLoad]);

  const onClickSaveBank = async () => {
    try {
      setLoadingBank(true);

      if (!form.bankAccName || !form.bankNo) {
        await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
        return;
      }

      // if (!form.bankBrachCode) {
      //   await EmitterStatus("ERROR", { text: "กรุณากรอกรหัสสาขา" });
      //   return;
      // }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          bankBrachCode: form.bankBrachCode,
          bankAccName: form.bankAccName,
          bankNo: form.bankNo,
          bank: form.bank,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "ข้อมูลธนาคาร",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingBank(false);
    }
  };

  const onClickSaveCar = async () => {
    try {
      setLoadingCar(true);

      // if (form?.loan_status === "งานสำเร็จแล้ว") {
      //   if (
      //     !form.issueDate ||
      //     !form.serialNumber ||
      //     !form.distance ||
      //     !form.insuranceExpireDate ||
      //     !form.tankNumber ||
      //     !form.subModel ||
      //     !form.plate
      //   ) {
      //     await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
      //     return;
      //   }
      // }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          color: form.color,
          issueDate: form.issueDate,
          serialNumber: form.serialNumber,
          distance: form.distance,
          insuranceExpireDate: form.insuranceExpireDate,
          registerExpireDate: form.registerExpireDate,
          tankNumber: form.tankNumber,
          subModel: form.subModel,
          plate: form.plate,
          plate_province: form.plate_province,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "ข้อมูลรถ",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingCar(false);
    }
  };

  const onClickSaveInformation = async () => {
    try {
      setLoadingInformation(true);

      if (form?.loan_status === "งานสำเร็จแล้ว") {
        if (!form.amount || !form.requestamount || !form.ltv) {
          await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
          return;
        }
      } else {
        if (!form.amount || !form.requestamount) {
          await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
          return;
        }
      }

      if (form.amount > form.requestamount) {
        await EmitterStatus("ERROR", {
          text: "วงที่ขอต้องไม่เกินวงที่ได้รับ",
        });
        return;
      }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          stamp_dropdown: form?.stamp_dropdown,
          estimate_car_dropdown: form?.estimate_car_dropdown,
          fee_motorbike_dropdown: form?.fee_motorbike_dropdown,
          fee_inspection_dropdown: form?.fee_inspection_dropdown,
          fee_transfer_dropdown: form?.fee_transfer_dropdown,
          fee_transfer: form?.fee_transfer,
          fee_service_dropdown: form?.fee_service_dropdown,
          fee_service: form?.fee_service,
          fee_inspection: form?.fee_inspection,
          value: form.value,
          ltv: form.ltv,
          requestamount: form.requestamount,
          amount: form.amount,
          period: form.period,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "ข้อมูลสินเชื่อ",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingInformation(false);
    }
  };

  const onClickSavePersonal = async () => {
    try {
      setLoadingPersonalSave(true);

      if (
        !form.name ||
        !form.lastname ||
        !form.nickname ||
        !form.citizenid ||
        !form.hashCitizen ||
        !form.citizenexpiredate ||
        !form.gender ||
        !form.birthdateTh ||
        !form.marritalStatus ||
        !form.education ||
        !form.email ||
        !form.addressCode ||
        !form.addressDesc ||
        !form.addressProvince ||
        !form.addressDistrict ||
        !form.addressSubDistrict ||
        !form.addressSubDistrictZipCode ||
        !form.officialAddressCode ||
        !form.officialAddressDesc ||
        !form.currentAddressProvince ||
        !form.currentAddressDistrict ||
        !form.currentAddressSubDistrict ||
        !form.currentAddressSubDistrictZipCode ||
        (form.marritalStatus === "สมรส" &&
          (!form.articlePartner || !form.namePartner || !form.lastnamePartner))
        // !form.phoneNumberPartner
      ) {
        await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
        return;
      }

      if (String(form?.citizenid).length < 13) {
        await EmitterStatus("ERROR", {
          text: "กรุณากรอกเลขบัตรประชาชนให้ครบถ้วน",
        });
        return;
      }

      if (String(form?.hashCitizen).length < 14) {
        await EmitterStatus("ERROR", {
          text: "กรุณากรอกรหัสหลังบัตรให้ครบถ้วน",
        });
        return;
      }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          article: form.article,
          fullname: `${form?.name} ${form?.lastname}`,
          name: form.name,
          lastname: form.lastname,
          nickname: form.nickname,
          citizenid: form.citizenid,
          hashCitizen: form.hashCitizen,
          citizenexpiredate: form.citizenexpiredate,
          gender: form.gender,
          birthdateTh: form.birthdateTh,
          marritalStatus: form.marritalStatus,
          articlePartner: form.articlePartner,
          namePartner: form.namePartner,
          lastnamePartner: form.lastnamePartner,
          phoneNumberPartner: form.phoneNumberPartner,
          childern: form.childern,
          education: form.education,
          phone_number: form.phone_number,
          email: form.email,
          lineid: form.lineid,
          addressCode: form.addressCode,
          addressDesc: form.addressDesc,
          addressProvince: form.addressProvince,
          addressDistrict: form.addressDistrict,
          addressSubDistrict: form.addressSubDistrict,
          addressSubDistrictZipCode: form.addressSubDistrictZipCode,
          officialAddressCode: form.officialAddressCode,
          officialAddressDesc: form.officialAddressDesc,
          currentAddressProvince: form.currentAddressProvince,
          currentAddressDistrict: form.currentAddressDistrict,
          currentAddressSubDistrict: form.currentAddressSubDistrict,
          currentAddressSubDistrictZipCode:
            form.currentAddressSubDistrictZipCode,

          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "ข้อมูลส่วนบุคคล",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingPersonalSave(false);
    }
  };

  const onClickSaveDebt = async () => {
    try {
      setLoadingDebtSave(true);

      if (form?.dataDebt?.length > 0) {
        for (const debtItem of form?.dataDebt) {
          if (
            !String(debtItem?.payperinsallment).length ||
            !String(debtItem?.amount).length
          ) {
            await EmitterStatus("ERROR", { text: "กรุณากรอกข้อมูลให้ครบถ้วน" });
            return;
          }
        }
      }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          dataDebt: form?.dataDebt || [],
          income: form?.income,
          burden: form?.burden,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "ข้อมูลการเงิน",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingDebtSave(false);
    }
  };

  const onClickRelationSaveEdit = async (relation = "") => {
    try {
      if (relation === "") {
        setLoadingRelationOne(true);
      } else {
        setLoadingRelationTwo(true);
      }

      const key = relation;

      const formRelation = {
        [`referalName${key}`]: form[`referalName${key}`],
        [`referalPhone${key}`]: form[`referalPhone${key}`],
        [`relation${key}`]: form[`relation${key}`],
        [`referalWork${key}`]: form[`referalWork${key}`],
        [`referal_${key === "" ? "one" : "two"}`]:
          form[`referal_${key === "" ? "one" : "two"}`],
      };

      // referalName
      // referalPhone
      // relation
      // referalWork
      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          ...formRelation,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: `บุคคลอ้างอิงลำดับที่ ${key === "" ? "1" : "2"}`,
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      if (relation === "") {
        setLoadingRelationOne(false);
      } else {
        setLoadingRelationTwo(false);
      }
    }
  };

  function charIsLetter(char) {
    if (typeof char !== "string") {
      return false;
    }

    return /^[a-zA-Z]+$/.test(char);
  }

  function isNumber(char) {
    return /^\d+$/.test(char);
  }

  function mask(patterns = "", value) {
    let newValue = "";
    for (let i = 0; i < patterns.length; i++) {
      const pattern = String(patterns[i]);
      if (!value[i]) {
        newValue += "";
      } else {
        if (pattern === "-") {
          newValue += "-";
          if (pattern === "A") {
            if (charIsLetter(value[i])) {
              newValue += value[i];
            } else {
              break;
            }
          } else if (pattern === "0") {
            if (isNumber(value[i])) {
              newValue += value[i];
            } else {
              break;
            }
          }
        }
        if (pattern === "A") {
          if (charIsLetter(value[i])) {
            newValue += value[i];
          } else {
            break;
          }
        } else if (pattern === "0") {
          if (isNumber(value[i])) {
            newValue += value[i];
          } else {
            break;
          }
        }
      }
    }

    return newValue;
  }

  const fetchYears = async () => {
    const dataYears = await API.get(
      "MoneyHubAdmin",
      `/year/model/${leasing_request.model}`,
      {
        queryStringParameters: {
          type: leasing_request.type,
        },
      },
      1338
    );
    if (dataYears?.years?.length > 0) {
      setYearOptions(
        dataYears.years.map((year) => {
          return {
            label: year.year,
            value: year.year,
            ...year,
          };
        })
      );
    }
  };

  const onClickHistory = async () => {
    try {
      setLoadingHistories(true);
      const data = await API.get(
        "MoneyHubAdmin",
        "/leasing/histories/" + leasing_request?.request_id
      );
      setHistories(data?.histories);
      setOpenModalHistories(true);
    } catch (error) {
      console.log("open history", error);
    } finally {
      setLoadingHistories(false);
    }
  };

  const queryFCR = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/fcr/${leasing_request?.request_id}`,
        {
          queryStringParameters: {},
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setFcr(data?.fcr);
    } catch (error) {
      console.log("query fcr", error);
    }
  };

  const onChangeAttachment = (e) => {
    const files = e.target.files;
    const filesArr = Array.prototype.slice.call(e.target.files);
    setForm((prev) => {
      return { ...prev, attachmentViews: filesArr, attachments: files };
    });
    setCheckEdit(true);
  };

  const onChangeEditDebt = (name, value, index) => {
    setForm((prev) => {
      const temp = { ...prev };
      temp.dataDebt[index][name] = value;
      return { ...prev };
    });
  };

  const onClickDeleteDebt = (index) => {
    setForm((prev) => {
      const temp = { ...prev };
      temp.dataDebt.splice(index, 1);
      return { ...prev };
    });
  };

  const onClickAddDebt = () => {
    setForm((prev) => {
      return {
        ...prev,
        dataDebt: [
          ...prev.dataDebt,
          {
            type: DEBT_OPTIONS[0]?.value,
            amount: "",
            payperinsallment: "",
          },
        ],
      };
    });
  };

  const queryAttachment = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/attachment/${form.phone_number}`,
        {
          queryStringParameters: {},
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const signedAttachments = [];
      if (data?.attachments?.length > 0) {
        for (const attachment of data?.attachments) {
          const signedURL = await Storage.get(attachment);
          signedAttachments.push({ name: attachment, link: signedURL });
        }
      }

      setCheckCreate(!!data?.attachments);
      setOriAttachments(signedAttachments);
    } catch (error) {
      console.log("Query Attachment", error);
    }
  };

  const uploadAttachment = async () => {
    try {
      let attachments = [];
      if (form.attachments.length > 0) {
        const today = getCurrentLocalDateTime();
        for (const attachment of form.attachments) {
          const fileName = `${today.fullDate}_${today.hours}:${today.minutes}_${attachment?.name}`;
          const keyImg = await Storage.put(fileName, attachment);
          attachments.push(keyImg.key);
        }
      }
      if (oriAttachments.length > 0) {
        attachments = [
          ...oriAttachments.map((attachment) => attachment.name),
          ...attachments,
        ];
      }
      return attachments;
    } catch (error) {
      console.log("Upload Error Attachment", error);
    }
  };

  const onSaveAttachment = async () => {
    try {
      setLoadingSaveAttachment(true);
      const attachments = await uploadAttachment();
      if (checkCreate) {
        await API.put(
          "MoneyHubAdmin",
          `/leasing/attachment/${form.phone_number}`,
          {
            body: {
              attachments,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
      } else {
        await API.post("MoneyHubAdmin", `/leasing/attachment`, {
          body: {
            phone_number: form.phone_number,
            request_id: form.request_id,
            attachments,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
      await EmitterStatus("SUCCESS");
      await queryAttachment();
    } catch (error) {
      console.log("onSaveAttachment", error);
    } finally {
      await queryAttachment();
      setLoadingSaveAttachment(false);
      setForm((prev) => {
        return {
          ...prev,
          attachments: [],
          attachmentViews: [],
        };
      });
      setCheckEdit(false);
      fileRef.current.value = "";
    }
  };

  const onDeleteAttachment = (index) => {
    const filterAttachments = oriAttachments.filter(
      (_, myIndex) => myIndex !== index
    );
    setOriAttachments(filterAttachments);
    setCheckEdit(true);
  };

  const findGroupByYearForNTF = () => {
    let ltvGroups = [];

    if (form.category === "TF") {
      for (const groupTF of group.tf) {
        ltvGroups = groupTF.groups;
      }
      setLtvGroups(ltvGroups);
      return;
    }

    for (const groupNTF of group.ntf) {
      const [year] = form?.year?.split(" ");
      if (groupNTF.years.includes(year)) {
        ltvGroups = groupNTF.groups;
        break;
      }
    }
    setLtvGroups(ltvGroups);
  };

  function escapeRegExp(string) {
    return String(string)?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  }

  function replaceAll(str, find, replace) {
    return String(str)?.replace(new RegExp(escapeRegExp(find), "g"), replace);
  }

  const onChangeForm = (e) => {
    const { name, value } = e.target;

    if (String(name).indexOf("hashCitizen") > -1) {
      setForm((prev) => {
        const temp = { ...prev };
        const newValue = mask("AA0-0000000-00", String(value));
        return { ...temp, [name]: newValue };
      });
      return;
    }

    if (
      String(name).indexOf("amount") > -1 ||
      String(name).indexOf("requestamount") > -1
    ) {
      const splitComma = String(value).split(",");
      if (splitComma.length > 0) {
        const newValue = replaceAll(value, ",", "");
        setForm({ ...form, [name]: Number(newValue) });
        return;
      } else {
        setForm({ ...form, [name]: Number(value) });
        return;
      }
    }

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeFormDate = (name) => (date, dateString) => {
    const [day, month, year] = dateString.split("-");
    setForm({ ...form, [name]: `${year}-${month}-${day}` });
  };

  const onChangeCheckBox = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    setForm({ ...form, [name]: value });
  };

  const onChangeFile = async (e) => {
    const { name } = e.target;

    if (name === "statementUris") {
      const displayFiles = [];
      for (const file of e.target.files) {
        displayFiles.push({ value: file.name, file, display: true });
      }
      setForm({
        ...form,
        statementUris: [
          ...(form.statementUris &&
            form.statementUris?.filter((statmentUri) => !statmentUri?.display)),
          ...displayFiles,
        ],
      });
      return;
    }

    const file = e.target.files[0];
    setForm((prev) => {
      return {
        ...prev,
        [name]: file,
      };
    });
  };

  const fetchId = async () => {
    try {
      setLoadingId(true);
      const data = await API.get(
        "MoneyHubAdmin",
        `/leasing/request/${leasing_request.request_id}`,
        {
          body: {
            ...form,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const newForm = _.cloneDeep({
        ...form,
        ...data.leasing,
        ori_statementUris: data?.leasing?.statementUris
          ? tryParseJSON(data?.leasing?.statementUris)
          : [],
        ori_pdpaUri: data?.leasing?.pdpaUri,
        ori_creditUri: data?.leasing?.creditUri,
        ori_fileBuro: data?.leasing?.fileBuro,
        pdpaUri: data?.leasing?.pdpaUri
          ? await Storage.get(data?.leasing?.pdpaUri)
          : "",
        creditUri: data?.leasing?.creditUri
          ? await Storage.get(data?.leasing?.creditUri)
          : "",
        fileBuro: data?.leasing?.fileBuro
          ? await Storage.get(data?.leasing?.fileBuro)
          : "",
        statementUris: !data?.leasing.statementUris
          ? ""
          : await getStatments(tryParseJSON(data?.leasing.statementUris)),
        transferDate: getDefaultPayDate(),
        addressProvince: getProvince(data.leasing?.address),
        addressDistrict: getDistrict(data.leasing?.address),
        addressSubDistrict: getSubDistrict(data.leasing?.address),
        currentAddressProvince: getProvince(data.leasing?.currentAddress),
        currentAddressDistrict: getDistrict(data.leasing?.currentAddress),
        currentAddressSubDistrict: getSubDistrict(data.leasing?.currentAddress),
        birthdateTh: SetDate(data.leasing?.birthdateTh),
        citizenexpiredate: SetDate(data.leasing?.citizenexpiredate),
        addressSubDistrictZipCode: getZipCode(data.leasing?.address),
        currentAddressSubDistrictZipCode: getZipCode(
          data.leasing?.currentAddress
        ),
        addressProvinceGrt: getProvince(data.leasing?.addressGrt),
        addressDistrictGrt: getDistrict(data.leasing?.addressGrt),
        addressSubDistrictGrt: getSubDistrict(data.leasing?.addressGrt),
        currentAddressProvinceGrt: getProvince(data.leasing?.currentAddressGrt),
        currentAddressDistrictGrt: getDistrict(data.leasing?.currentAddressGrt),
        currentAddressSubDistrictGrt: getSubDistrict(
          data.leasing?.currentAddressGrt
        ),
        birthdateThGrt: SetDate(data.leasing?.birthdateThGrt),
        citizenexpiredateGrt: SetDate(data.leasing?.citizenexpiredateGrt),
        addressSubDistrictZipCodeGrt: getZipCode(data.leasing?.addressGrt),
        beginjobdate: SetDate(data.leasing?.beginjobdate),
        currentAddressSubDistrictZipCodeGrt: getZipCode(
          data.leasing?.currentAddressGrt
        ),
        ltv: SetLtv(data.leasing?.ltv, data.leasing?.grade_ltv),
      });
      setForm(newForm);
      setTemp(_.cloneDeep(newForm));
      leasing_request = data?.leasing;
    } catch (error) {
      console.log("fetch id error", error);
    } finally {
      setLoadingId(false);
    }
  };

  const loginDopa = async () => {
    const { data } = await axios.post(`${baseApiDopa}/api/jwt/login`, {
      username: "Officer",
      password: "123456",
    });
    return data.token;
  };

  const postDopa = async (form) => {
    const token = localStorage.getItem("token_dopa");

    const { data } = await axios.post(
      `${baseApiDopa}/api/laser`,
      {
        pid: form.pid,
        fname: form.fname,
        lname: form.lname,
        dob: Number(form.dob),
        laser: form.laser,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (data.isError || data.code !== 0) {
      await EmitterStatus("ERROR", { text: data.desc });
    } else {
      await EmitterStatus("SUCCESS", { text: data.desc });
    }
  };

  const setTokenDopa = (token) => {
    localStorage.setItem("token_dopa", token);
    localStorage.setItem("token_dopa_last_active", new Date().getTime());
  };

  const getDOBFormatNumber = (dob) => {
    const splitBirthDate = String(dob).split("/");
    const year = splitBirthDate[2];
    const month = splitBirthDate[1];
    const day = splitBirthDate[0];
    return Number(`${year}${month}${day}`);
  };

  const getName = (name) => {
    const splitName = String(name).split(" ");
    return {
      first_name: splitName[0],
      last_name: splitName[1],
    };
  };

  const getLaser = (hashCitizen) => {
    const hash = String(hashCitizen).split("-");
    return hash.join("");
  };

  const getFormDopaLaser = () => {
    const form = {
      pid: Number(leasing_request.citizenid),
      fname: leasing_request.name,
      lname: leasing_request.lastname,
      dob: getDOBFormatNumber(leasing_request.birthdateTh),
      laser: getLaser(leasing_request.hashCitizen),
    };

    return form;
  };

  const onClickCheck = async () => {
    try {
      setLoadingCheck(true);
      const tokenDopa = localStorage.getItem("token_dopa");
      const lastActive = localStorage.getItem("token_dopa_last_active");
      const today = new Date().getTime();

      if (!tokenDopa) {
        const token = await loginDopa();
        setTokenDopa(token);
        await postDopa(getFormDopaLaser());
      } else {
        // expire token
        if (today - lastActive > 1000 * 60 * 20) {
          console.log("tokenDopa", tokenDopa);
          const token = await loginDopa();
          setTokenDopa(token);
        }
        getFormDopaLaser();
        await postDopa(getFormDopaLaser());
      }
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", { text: "Something went wrong" });
    } finally {
      setLoadingCheck(false);
    }
  };

  const getButtonStatus = () => {
    const loan_status = form.loan_status;

    if (form?.loan_status === "ยืนยัน") return [btnCompleteTransfer()];
    if (user.username !== form?.reserveBy) return [];
    // if (leasing_request.loan_status === "รับคำร้อง") {
    //   return [btnCancel(), btnCalling()];
    // }

    switch (loan_status) {
      case "รออนุมัติ":
        return [btnCompleteJob(), btnReject(), btnCalling()];
      case "นัดหมายแล้ว":
      case "รอตรวจ":
        return [btnCancel(), btnReject()];
      case "รอนัดหมาย":
        return [btnReject()];
      case "รอติดต่อบุคคลอ้างอิง":
        return [btnSendToFCR(), btnCompleteJob(), btnApprove(), btnReject()];
      case "งานสำเร็จแล้ว":
        return [btnCompleteJob(), btnApprove(), btnSendCheck(), btnReject()];
      case "ไม่ผ่าน":
      case "อนุมัติ":
        return [];
      case "ยืนยัน":
        return [];
      case "สมบูรณ์":
        return [];
      default:
        return [
          btnSendToFCR(),
          // btnCompleteJob(),
          // btnApprove(),
          btnReject(),
          btnCalling(),
        ];
    }
  };

  const onReturn = async () => {
    setStatus("รอผู้ยื่นคำร้องแก้ไข");
    try {
      let executeTime = getCurrentLocalDateTime();
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (!form.reason) {
            setError(true);
            return { error: true };
          }
          await API.put(
            "MoneyHubAdmin",
            `/leasing/requestStatus/${leasing_request.request_id}`,
            {
              body: {
                fileBuro: "",
                deviceToken: leasing_request?.deviceToken, //M
                reason: form.reason,
                new_loan_status: "รอผู้ยื่นคำร้องแก้ไข",
                adminNameLatest: leasing_request?.adminName,
                adminName: user.username,
                bankBrachCode: form?.bankBrachCode
                  ? form.bankBrachCode.slice(0, 4)
                  : "",
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: "โปรดกรอกเหตุผลในการตีกลับ",
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await refetch(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onRejectJob = async () => {
    setStatus("ไม่ผ่าน");
    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const date = today.getDate();
      let executeTime = getCurrentLocalDateTime();
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะปฏิเสธคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            await API.put(
              "MoneyHubAdmin",
              `/leasing/requestStatus/${leasing_request.request_id}`,
              {
                body: {
                  deviceToken: leasing_request?.deviceToken,
                  fileBuro: "",
                  new_loan_status: "ไม่ผ่าน",
                  penaltytime: new Date(
                    year,
                    month,
                    date + 15,
                    "08",
                    "00",
                    "00"
                  ).getTime(),
                  reason:
                    form.reason || "ขอแสดงความเสียใจคำขอของคุณไม่ผ่านครับ",
                  referal_one: "",
                  referal_two: "",
                  adminName: user.username,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
          } catch (error) {
            await Swal.fire({
              title: "ERROR",
              text: "Something went wrong",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          }
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await refetch(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onCancelJob = async () => {
    setStatus("ยกเลิก");
    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const date = today.getDate();
      let executeTime = getCurrentLocalDateTime();
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะยกเลิกคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            await API.put(
              "MoneyHubAdmin",
              `/leasing/requestStatus/${leasing_request.request_id}`,
              {
                body: {
                  new_loan_status: "ยกเลิก",
                  adminName: user.username,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
            await API.post(
              "MoneyHubAdmin",
              `/leasing/histories/${leasing_request.request_id}`,
              {
                body: {
                  ...form,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
          } catch (error) {
            await Swal.fire({
              title: "ERROR",
              text: "Something went wrong",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          }
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await refetch(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onSendToFCR = async () => {
    setStatus("รอนัดหมาย");
    onClickSaveEdit(async () => {
      await API.put(
        "MoneyHubAdmin",
        `/leasing/requestStatus/${leasing_request.request_id}`,
        {
          body: {
            new_loan_status: "รอนัดหมาย",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
    }, "รอนัดหมาย");
  };

  const onSendCheck = async () => {
    setStatus("รอตรวจ");
    onClickSaveEdit(async () => {
      await API.put(
        "MoneyHubAdmin",
        `/leasing/requestStatus/${leasing_request.request_id}`,
        {
          body: {
            new_loan_status: "รอตรวจ",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
    }, "รอตรวจ");
  };

  const onCompleteTransfer = async () => {
    setStatus("ยืนยัน");
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัติคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (!form.tx) {
            setError(true);
            return {
              error: true,
              errorMessage: "โปรดกรอกเลขอ้างอิงการโอนงิน",
            };
          }

          try {
            await API.put(
              "MoneyHubAdmin",
              `/leasing/requestStatus/${leasing_request?.request_id}`,
              {
                body: {
                  new_loan_status:
                    _.upperCase(form.tx) !== "F"
                      ? "สมบูรณ์"
                      : "รอผู้ยื่นคำร้องแก้ไข",
                  reason:
                    _.upperCase(form.tx) !== "F"
                      ? ""
                      : "ธนาคารหรือเลขบัญชีของท่านผิดกรุณากรอกใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่",
                  transferDate: form.transferDate,
                  tx: form.tx,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );

            if (_.upperCase(form.tx) !== "F") {
              const createdLoan = await API.post(
                "MoneyHubAdmin",
                "/leasing/loan",
                {
                  body: {
                    transferDate: form.transferDate,
                    request_id: leasing_request?.request_id,
                  },
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );

              if (createdLoan.type === "E") {
                await Swal.fire({
                  title: "ERROR",
                  text: createdLoan?.message,
                  icon: "error",
                  confirmButtonText: "ยืนยัน",
                });
                return;
              }

              // await API.post(
              //   "MoneyHubAdmin",
              //   `/leasing/histories/${leasing_request.request_id}`,
              //   {
              //     body: {
              //       ...form,
              //     },
              //     headers: {
              //       Authorization: `Bearer ${(await Auth.currentSession())
              //         .getIdToken()
              //         .getJwtToken()}`,
              //     },
              //   }
              // );
            }

            //   if (row.original.refinance_id) {
            //     await API.put("MoneyHubAdmin", "/loan/refinanceLoan", {
            //       body: {
            //         refinance_id: row.original.refinance_id,
            //       },
            //     });
            //   }
            // }
          } catch (error) {
            await Swal.fire({
              title: "ERROR",
              text: error?.response?.data?.message
                ? error.response.data.message
                : "อัพเดตข้อมูลไม่สำเร็จ",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          }
        },
      });
      if (result.value?.error) {
        return await EmitterStatus("WARNING", {
          text: `โปรดกรอกข้อมูล${result.value.errorMessage}`,
        });
      }
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await refetch(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await EmitterStatus("ERROR", { logMessage: error });
    }
  };

  const onCompleteJob = async () => {
    setStatus("อนุมัติ");
    onClickSaveEdit(async () => {
      await API.put(
        "MoneyHubAdmin",
        `/leasing/requestStatus/${leasing_request.request_id}`,
        {
          body: {
            new_loan_status: "อนุมัติ",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
    }, "อนุมัติ");
  };

  const onCalling = async () => {
    setStatus("รอติดต่อบุคคลอ้างอิง");
    onClickSaveEdit(async () => {
      await API.put(
        "MoneyHubAdmin",
        `/leasing/requestStatus/${leasing_request?.request_id}`,
        {
          body: {
            new_loan_status: "รอติดต่อบุคคลอ้างอิง",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
    }, "รอติดต่อบุคคลอ้างอิง");
    // try {
    //   const result = await Swal.fire({
    //     title: "คุณยืนยันคำขอนี้หรือไม่ ?",
    //     showCancelButton: true,
    //     confirmButtonText: `บันทึก`,
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true,
    //     showLoaderOnDeny: false,
    //     preConfirm: async () => {
    //       let fileBuro = "";
    //       if (leasing_request.fileBuro) {
    //         fileBuro = leasing_request.originalBuro;
    //       } else if (form.fileBuro) {
    //         fileBuro = form.fileBuro;
    //         const fileName = `${new Date().getTime()}_${form?.fileBuro?.name}`;
    //         fileBuro = await Storage.put(fileName, form.fileBuro);
    //       }

    //       await API.put(
    //         "MoneyHubAdmin",
    //         `/leasing/infomation/${leasing_request.request_id}`,
    //         {
    //           body: {
    //             ...leasing_request,
    //             fileBuro,
    //           },
    //           headers: {
    //             Authorization: `Bearer ${(await Auth.currentSession())
    //               .getIdToken()
    //               .getJwtToken()}`,
    //           },
    //         }
    //       );

    //       await API.put(
    //         "MoneyHubAdmin",
    //         `/leasing/requestStatus/${leasing_request?.request_id}`,
    //         {
    //           body: {
    //             new_loan_status: "รอติดต่อบุคคลอ้างอิง",
    //           },
    //           headers: {
    //             Authorization: `Bearer ${(await Auth.currentSession())
    //               .getIdToken()
    //               .getJwtToken()}`,
    //           },
    //         }
    //       );

    //       await API.post(
    //         "MoneyHubAdmin",
    //         `/leasing/histories/${leasing_request.request_id}`,
    //         {
    //           body: {
    //             ...form,
    //           },
    //           headers: {
    //             Authorization: `Bearer ${(await Auth.currentSession())
    //               .getIdToken()
    //               .getJwtToken()}`,
    //           },
    //         }
    //       );
    //     },
    //   });
    //   if (!result.isConfirmed) return;
    //   await Swal.fire({
    //     title: "SUCCESS",
    //     text: "อัพเดตข้อมูลสำเร็จ",
    //     icon: "success",
    //     confirmButtonText: "ยืนยัน",
    //   });
    //   await refetch(query);
    // } catch (error) {
    //   console.log("Error ", error);
    //   await Swal.fire({
    //     title: "ERROR",
    //     text: "Something went wrong",
    //     icon: "error",
    //     confirmButtonText: "ยืนยัน",
    //   });
    // }
  };

  const onApprove = async () => {
    setStatus("รออนุมัติ");
    onClickSaveEdit(async () => {
      await API.put(
        "MoneyHubAdmin",
        `/leasing/requestStatus/${leasing_request?.request_id}`,
        {
          body: {
            new_loan_status: "รออนุมัติ",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
    }, "รออนุมัติ");

    // try {
    //   const result = await Swal.fire({
    //     title: "คุณยืนยันที่จะอนุมัติขั้นต้นคำขอนี้หรือไม่ ?",
    //     showCancelButton: true,
    //     confirmButtonText: `บันทึก`,
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true,
    //     showLoaderOnDeny: false,
    //     preConfirm: async () => {
    //       const queryRequireds = document.querySelectorAll(`[id^="required"]`);
    //       if (form.amount > getPriceLTV()) {
    //         await Swal.fire({
    //           title: "ไม่สามารถเกินวงเงินของค่า LTV ได้",
    //           icon: "error",
    //           confirmButtonText: "ยืนยัน",
    //         });
    //         return;
    //       } else if (queryRequireds.length > 0) {
    //         await Swal.fire({
    //           title: "กรุณากรอกข้อมูลให้ครบถ้วน",
    //           icon: "error",
    //           confirmButtonText: "ยืนยัน",
    //         });
    //         return;
    //       }

    //       let errorMessage = "";
    //       if (!form.referal_one) {
    //         errorMessage += " บุคคลอ้างอิงคนที่ 1";
    //       }
    //       if (!form.referal_two) {
    //         errorMessage += " บุคคลอ้างอิงคนที่ 2";
    //       }
    //       if (!form.fileBuro) {
    //         errorMessage += " ไฟล์บูโร";
    //       }
    //       // if (!form.pdpaUri) {
    //       //   errorMessage += "โปรดอัพโหลดเอกสาร PDPA";
    //       // }
    //       // if (!form.creditUri) {
    //       //   errorMessage += " โปรดอัพโหลดเอกสารสัญญากู้เงิน";
    //       // }
    //       if (!form.bankBrachCode) {
    //         errorMessage += " รหัสสาขา";
    //       }
    //       if (!form.bankBrachCode.length > 4) {
    //         errorMessage += " รหัสสาขาน้อยกว่า 4 หลัก";
    //       }
    //       if (isNaN(form.bankBrachCode)) {
    //         errorMessage += " รหัสสาขาต้องเป็นตัวเลขเท่านั้น";
    //       }

    //       if (errorMessage) {
    //         setError(true);
    //         return { error: true, errorMessage };
    //       }

    //       let fileBuro = "";
    //       if (leasing_request.originalBuro) {
    //         fileBuro = leasing_request.originalBuro;
    //       } else {
    //         fileBuro = form.fileBuro;
    //         const fileName = `${new Date().getTime()}_${form?.fileBuro?.name}`;
    //         fileBuro = await Storage.put(fileName, form.fileBuro);
    //       }

    //       await API.put(
    //         "MoneyHubAdmin",
    //         `/leasing/requestStatus/${leasing_request.request_id}`,
    //         {
    //           body: {
    //             fileBuro: fileBuro?.key ? fileBuro.key : fileBuro,
    //             deviceToken: leasing_request?.deviceToken,
    //             reason: "",
    //             new_loan_status: "รออนุมัติ",

    //             referal_one: form.referal_one,
    //             referal_two: form.referal_two,
    //             adminName: user.username,

    //             bankBrachCode: form?.bankBrachCode
    //               ? form.bankBrachCode.slice(0, 4)
    //               : "",
    //           },
    //           headers: {
    //             Authorization: `Bearer ${(await Auth.currentSession())
    //               .getIdToken()
    //               .getJwtToken()}`,
    //           },
    //         }
    //       );
    //     },
    //   });
    //   if (result.value?.error) {
    //     return await Swal.fire({
    //       title: "WARNING",
    //       text: `โปรดกรอกข้อมูล${result.value.errorMessage}`,
    //       icon: "warning",
    //       confirmButtonText: "ยืนยัน",
    //     });
    //   }
    //   if (!result.isConfirmed) return;
    //   await Swal.fire({
    //     title: "SUCCESS",
    //     text: "อัพเดตข้อมูลสำเร็จ",
    //     icon: "success",
    //     confirmButtonText: "ยืนยัน",
    //   });
    //   await refetch(query);
    // } catch (error) {
    //   console.log("Error ", error);
    //   await Swal.fire({
    //     title: "ERROR",
    //     text: "Something went wrong",
    //     icon: "error",
    //     confirmButtonText: "ยืนยัน",
    //   });
    // }
  };

  const btnSendToFCR = () => {
    if (
      checkRole(user?.groups, [
        "SuperAdmin",
        "Analyze",
        "AnalyzeApprove",
        "CustomerService",
        "Admin",
        "ApproveStaff",
      ])
    ) {
      return (
        <button
          onClick={onSendToFCR}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-mhs-orange text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Send To FCR
        </button>
      );
    }
  };

  const btnSendCheck = () => {
    if (
      checkRole(user?.groups, [
        "SuperAdmin",
        "Analyze",
        "AnalyzeApprove",
        "CustomerService",
      ])
    ) {
      return (
        <button
          onClick={onSendCheck}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-mhs-orange text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          รอตรวจ
        </button>
      );
    }
  };

  const btnCompleteTransfer = () => {
    // if (!checkRole()) return null;

    if (!isTransfer) return null;

    if (
      checkRole(user.groups, [
        "SuperAdmin",
        "Analyze",
        "AnalyzeApprove",
        "CustomerService",
      ])
    ) {
      return (
        <button
          onClick={onCompleteTransfer}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          อนุมัติการโอนเงิน
        </button>
      );
    }
  };

  const btnCompleteJob = () => {
    // if (!checkRole()) return null;

    if (checkRole(user.groups, ["SuperAdmin", "AnalyzeApprove"])) {
      return (
        <button
          onClick={onCompleteJob}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          อนุมัติ
        </button>
      );
    }
  };

  const btnApprove = () => {
    return (
      <button
        onClick={onApprove}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        รออนุมัติ
      </button>
    );
  };

  const btnReject = () => {
    return (
      <button
        onClick={onRejectJob}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-500 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        ไม่ผ่าน
      </button>
    );
  };

  const btnCancel = () => {
    return (
      <button
        onClick={onCancelJob}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        ยกเลิก
      </button>
    );
  };

  const btnReturn = () => {
    return (
      <button
        onClick={onReturn}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Return
      </button>
    );
  };

  const btnCalling = () => {
    return (
      <button
        onClick={onCalling}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-400 text-base font-medium text-white hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        ติดต่อบุคคลอ้างอิง
      </button>
    );
  };

  const queryAttachmentLoan = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/loan/attachment/${leasing_request.phone_number}`,
        {
          queryStringParameters: {
            request_id: leasing_request.request_id,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const signedAttachments = [];
      for (const attachment of data.Item.attachments) {
        const signedURL = await Storage.get(attachment);
        signedAttachments.push({ name: attachment, link: signedURL });
      }

      setOriAttachmentLoan(signedAttachments);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickSaveRemark = async () => {
    try {
      setLoadingRemark(true);
      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          careertype: form.careertype,
          company: form.company,
          job_phone: form.job_phone,
          job_address: form.job_address,
          jobposition: form.jobposition,
          beginjobdate: form.beginjobdate,
          remark: form.remark,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS", "บันทึกข้อมูลเรียบร้อย");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingRemark(false);
    }
  };

  const SetDistrict = (name, form, isChange = false) => {
    if (
      (name === "addressProvince" ||
        name === "currentAddressProvince" ||
        name === "addressProvinceGrt" ||
        name === "currentAddressProvinceGrt") &&
      form[name]
    ) {
      const results = ThaiAddress.search({
        province: form[name],
      });

      let tempDistrict = [];
      results.map((value) => {
        if (
          tempDistrict?.length > 0 &&
          value.city === tempDistrict[tempDistrict?.length - 1]
        );
        else tempDistrict.push(value.city);
      });
      if (name === "addressProvince") {
        setDistrict(tempDistrict);
      } else if (name === "addressProvinceGrt") {
        setDistrictGrt(tempDistrict);
      } else if (name === "currentAddressProvinceGrt") {
        setCurrentDistrictGrt(tempDistrict);
      } else {
        setCurrentDistrict(tempDistrict);
      }
      if (tempDistrict.length > 0 && isChange) {
        let district = "";

        if (name === "addressProvince") {
          district = "addressDistrict";
          setSubDistrict([]);
        } else if (name === "currentAddressProvince") {
          district = "currentAddressDistrict";
          setCurrentSubDistrict([]);
        } else if (name === "addressProvinceGrt") {
          district = "addressDistrictGrt";
          setSubDistrictGrt([]);
        } else {
          district = "currentAddressDistrictGrt";
          setCurrentSubDistrictGrt([]);
        }

        setForm((prev) => {
          let updateObj = {};

          if (district === "addressDistrict") {
            updateObj = {
              ...prev,
              addressSubDistrict: "",
            };
          } else if (district === "currentAddressDistrict") {
            updateObj = {
              ...prev,
              currentAddressSubDistrict: "",
            };
          } else if (district === "addressDistrictGrt") {
            updateObj = {
              ...prev,
              addressSubDistrictGrt: "",
            };
          } else if (district === "currentAddressDistrictGrt") {
            updateObj = {
              ...prev,
              currentAddressSubDistrictGrt: "",
            };
          }

          return {
            ...prev,
            ...updateObj,
            [district]: "",
          };
        });
      }
    } else if (
      name === "addressDistrict" ||
      name === "currentAddressDistrict" ||
      name === "addressDistrictGrt" ||
      name === "currentAddressDistrictGrt"
    ) {
      let keyDistrict = "";
      let province = "";
      if (name === "addressDistrict") {
        keyDistrict = "addressSubDistrict";
        province = "addressProvince";
      } else if (name === "currentAddressDistrict") {
        keyDistrict = "currentAddressSubDistrict";
        province = "currentAddressProvince";
      } else if (name === "addressDistrictGrt") {
        keyDistrict = "addressSubDistrictGrt";
        province = "addressProvinceGrt";
      } else {
        keyDistrict = "currentAddressSubDistrictGrt";
        province = "currentAddressProvinceGrt";
      }

      const results = ThaiAddress.search({
        province: form[province],
      });
      let tempSubDistrict = [];
      results.map((value) => {
        if (value?.city === form[name]) {
          tempSubDistrict.push({
            value: value.tumbon,
            postcode: value.zipcode,
          });
        }
      });

      if (form[name] == "พญาไท") {
        tempSubDistrict.push({ value: "พญาไท", postcode: "10400" });
      } else if (form[name] == "ดินแดง") {
        tempSubDistrict.push({ value: "รัชดาภิเษก", postcode: "10400" });
      } else if (form[name] == "พระโขนง") {
        tempSubDistrict.push({ value: "พระโขนงใต้", postcode: "10260" });
      } else if (form[name] == "สวนหลวง") {
        tempSubDistrict.push({ value: "อ่อนนุช", postcode: "10250" });
        tempSubDistrict.push({ value: "พัฒนาการ", postcode: "10250" });
      } else if (form[name] == "บางนา") {
        tempSubDistrict.push({ value: "บางนาเหนือ", postcode: "10260" });
        tempSubDistrict.push({ value: "บางนาใต้", postcode: "10260" });
      } else if (form[name] == "บางบอน") {
        tempSubDistrict.push({ value: "บางพราน", postcode: "10150" });
        tempSubDistrict.push({ value: "บางบอนเหนือ", postcode: "10150" });
        tempSubDistrict.push({ value: "บางบอนใต้", postcode: "10150" });
        tempSubDistrict.push({ value: "คลองบางบอน", postcode: "10150" });
      }

      const filterDupSub = tempSubDistrict.reduce((acc, current) => {
        const x = acc.find((item) => item.value === current.value);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      if (name === "addressDistrictGrt") {
        setSubDistrictGrt(filterDupSub);
      } else if (name === "currentAddressDistrictGrt") {
        setCurrentSubDistrictGrt(filterDupSub);
      } else if (name === "addressDistrict") {
        setSubDistrict(filterDupSub);
      } else {
        setCurrentSubDistrict(filterDupSub);
      }

      if (filterDupSub.length > 0 && isChange) {
        setForm((prev) => {
          return {
            ...prev,
            [keyDistrict]: `${filterDupSub[0].value}`,
            [`${keyDistrict}ZipCode`]: `${filterDupSub[0].postcode}`,
          };
        });
      }
    }
  };

  const onClickSaveEdit = async (cb, loan_status = "") => {
    try {
      if (loan_status === "อนุมัติ" || loan_status === "รออนุมัติ") {
        if (switch_val?.SWITCH_ADMIN_VAL === "true") {
          setCheckClickSubmit(true);
        }
      } else {
        setCheckClickSubmit(false);
      }

      const result = await Swal.fire({
        title: "บันทึกข้อมูล ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          const today = getCurrentLocalDateTime();
          const formatDate = `${today.year}${today.month}${today.date}-${today.hours}_${today.minutes}_${today.seconds}`;
          const formatId = `${leasing_request?.request_id}_${formatDate}`;
          const queryRequireds = document.querySelectorAll(`[id^="required"]`);

          // console.log("queryRequireds", queryRequireds);

          // if (
          //   form?.requestamount > getPriceLTV() &&
          //   loan_status === "งานสำเร็จแล้ว"
          // ) {
          //   await Swal.fire({
          //     title: "ไม่สามารถเกินวงเงินของค่า LTV ได้",
          //     icon: "error",
          //     confirmButtonText: "ยืนยัน",
          //   });
          // } else
          if (
            queryRequireds.length > 0 &&
            loan_status !== "รอติดต่อบุคคลอ้างอิง"
          ) {
            await Swal.fire({
              title: "กรุณากรอกข้อมูลให้ครบถ้วน",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          } else {
            let errorMessage = "";

            if (!loan_status !== "รอติดต่อบุคคลอ้างอิง") {
              // if (!form.referal_one) {
              //   errorMessage += " บุคคลอ้างอิงคนที่ 1";
              // }
              // if (!form.referal_two) {
              //   errorMessage += " บุคคลอ้างอิงคนที่ 2";
              // }
              // if (!form.fileBuro && loan_status === "งานสำเร็จแล้ว") {
              //   errorMessage += " ไฟล์บูโร";
              // }
              // if (form?.age <= 0 || form?.ageGrt <= 0) {
              //   errorMessage += " อายุห้ามน้อยกว่าเท่ากับศูนย์";
              // }

              // if (!form.pdpaUri) {
              //   errorMessage += "โปรดอัพโหลดเอกสาร PDPA";
              // }
              // if (!form.creditUri) {
              //   errorMessage += " โปรดอัพโหลดเอกสารสัญญากู้เงิน";
              // }

              // if (!form.bankBrachCode && loan_status === "งานสำเร็จแล้ว") {
              //   errorMessage += " รหัสสาขา";
              // }
              // if (!form.bankBrachCode.length > 4) {
              //   errorMessage += " รหัสสาขาน้อยกว่า 4 หลัก";
              // }
              // if (isNaN(form.bankBrachCode)) {
              //   errorMessage += " รหัสสาขาต้องเป็นตัวเลขเท่านั้น";
              // }

              if (errorMessage) {
                setError(true);
                return { error: true, errorMessage };
              }
            }
            // else {
            //   console.log("in");
            //   if (
            //     !form.referalName ||
            //     !form.referalPhone ||
            //     !form.relation ||
            //     !form.referalWork ||
            //     !form.referal_one ||
            //     !form.referalName2 ||
            //     !form.referalPhone2 ||
            //     !form.relation2 ||
            //     !form.referalWork2 ||
            //     !form.referal_two
            //   ) {
            //     errorMessage += "โปรดกรอกบุคคลอ้างอิงให้ครบถ้วน";
            //   }
            //   if (errorMessage) {
            //     setError(true);
            //     return { error: true, errorMessage };
            //   }
            // }

            const pdpaUri = form.pdpaUri;
            const creditUri = form.creditUri;
            const fileBuro = form.fileBuro;

            if (typeof pdpaUri === "object" && pdpaUri) {
              const type = pdpaUri?.name?.split(".").pop();
              const pdpaUriFile = await Storage.put(
                `${formatId}_pdpa.${type}`,
                pdpaUri
              );
              form.pdpaUri = pdpaUriFile?.key;
            }
            if (String(form.pdpaUri).startsWith("https")) {
              form.pdpaUri = leasing_request.ori_pdpaUri;
            }

            if (typeof creditUri === "object" && creditUri) {
              const type = creditUri?.name?.split(".").pop();
              const creditUriFile = await Storage.put(
                `${formatId}_credit.${type}`,
                creditUri
              );
              form.creditUri = creditUriFile?.key;
            }
            if (String(form.creditUri).startsWith("https")) {
              form.creditUri = leasing_request.ori_creditUri;
            }

            if (typeof fileBuro === "object" && fileBuro) {
              const type = fileBuro?.name?.split(".").pop();
              const fileBuroFile = await Storage.put(
                `${formatId}_buro.${type}`,
                fileBuro
              );
              form.fileBuro = fileBuroFile?.key;
            }
            if (String(form.fileBuro).startsWith("https")) {
              form.fileBuro = leasing_request.ori_fileBuro;
            }

            if (form?.statementUris?.length > 0) {
              let newStatments = [];
              let index = 0;
              for (const statementUri of form.statementUris) {
                if (typeof statementUri?.file === "object" && statementUri) {
                  const type = statementUri?.file?.name?.split(".").pop();
                  const statementUriFile = await Storage.put(
                    `${formatId}_statement_${index + 1}.${type}`,
                    statementUri
                  );
                  newStatments.push(statementUriFile?.key);
                } else {
                  const findExist = form?.statementUris?.find(
                    (_, localIndex) => localIndex === index
                  );
                  if (findExist) {
                    newStatments.push(form.ori_statementUris[index]);
                  }
                }
                index++;
              }
              form.statementUris = JSON.stringify(newStatments);
            }

            await API.put(
              "MoneyHubAdmin",
              `/leasing/infomation/${leasing_request.request_id}`,
              {
                body: {
                  ...form,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
            if (typeof cb === "function") {
              await cb();
            }
            await API.post(
              "MoneyHubAdmin",
              `/leasing/histories/${leasing_request.request_id}`,
              {
                body: {
                  ...form,
                  action: "เปลี่ยนสถานะ",
                  adminName: user.username,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
          }
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูล${result.value.errorMessage}`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      // await fetchId();
      setOpenModal(false);
      await refetch(query);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "ERROR",
        text: "อัพเดตข้อมูลไม่สำเร็จ",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const getLTV = (ltv = "") => {
    if (ltv.length > 0) {
      const ltvSplit = ltv.split("(");
      const ltvSpaceSplit = ltv.split(" ");
      const ltvValue = Number(ltvSplit[1].replace(")", ""));
      const grade_ltv = ltvSpaceSplit[1]?.trim();
      return { ltv: ltvValue, grade_ltv };
    }
    return { ltv: 0, grade_ltv: "" };
  };

  const getPriceLTV = (localForm = form) => {
    const formLtv = getLTV(localForm.ltv);
    const cal_percent = +localForm.value * (+formLtv.ltv / 100);
    return cal_percent;
    // const cal_price = +localForm?.value + cal_percent;
    // return cal_price;
  };

  const onChangeSelect = (name) => (e) => {
    SetDistrict(name, { ...form, [name]: e?.value }, true);

    if (
      name === "addressSubDistrict" ||
      name === "currentAddressSubDistrict" ||
      name === "addressSubDistrictGrt" ||
      name === "currentAddressSubDistrictGrt"
    ) {
      setForm((prev) => {
        return {
          ...prev,
          [name]: e?.value,
          [`${name}Postcode`]: e?.postcode,
        };
      });
    } else {
      setForm((prev) => {
        if (
          (name === "year" || name === "period") &&
          leasing_request?.category === "TF"
        ) {
          const valueYear = name === "period" ? form.year : e?.value;
          const valuePeriod = name === "year" ? form.period : e?.value;

          const newInterest = findInterestTF(
            interest.tf.INTEREST_TF,
            valueYear,
            valuePeriod
          );

          return {
            ...prev,
            // raw_interest: prev?.raw_interest,
            // interest: prev?.interest,
            raw_interest: newInterest.interest_tf,
            interest: newInterest.interest_tf_eff,
            // interest: round(
            //   getInterestReduction(form.amount, newInterest, valuePeriod),
            //   2
            // ),
            [name]: e?.value,
          };
        }

        if (name === "ltv") {
          const cal_price = getPriceLTV({ ...form, ltv: e?.value });
          return {
            ...prev,
            ltv: e.value,
            requestamount: round(cal_price, 0),
            // amount:
            //   prev.amount > round(cal_price, 0)
            //     ? round(cal_price, 0)
            //     : prev.amount,
          };
        }
        return {
          ...prev,
          [name]: e.value,
        };
      });
    }
  };

  const getLtvOptions = () => {
    return ltvGroups.map((group) => {
      return {
        ...group,
        label: `Grade ${group.grade} (${group.ltv})`,
        value: `Grade ${group.grade} (${group.ltv})`,
      };
    });
  };

  const findInterestTF = (INTEREST_TF = [], year, period) => {
    let interest_tf = 0;
    let interest_tf_eff = 0;
    for (const INTEREST_TF_ITEM of INTEREST_TF) {
      if (
        String(INTEREST_TF_ITEM.name) === String(String(year)?.split(" ")[0])
      ) {
        interest_tf = INTEREST_TF_ITEM[`period_${period}`];
        interest_tf_eff = INTEREST_TF_ITEM[`period_${period}_eff`];
        break;
      }
    }

    if (form.stop_recal_interest === "true") {
      interest_tf = form.raw_interest;
      interest_tf_eff = form.interest;
    }
    return { interest_tf, interest_tf_eff };
  };

  const getAge = (name) => {
    const birthDate = new Date(form[name]);
    const today = new Date();
    return today.getFullYear() - birthDate.getFullYear();
  };

  const getAgePosition = (dateString) => {
    var today = new Date(getCurrentLocalDateTime().isoDateTime);
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const getAgeMonth = (dateString) => {
    var today = new Date(getCurrentLocalDateTime().isoDateTime);
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    return age * 12 + m;
  };

  const getPayPerMonthNoVat = () => {
    const calamount = form?.amount;

    const interestNTF = ["CAR", "TRUCK"].includes(form.type)
      ? interest.ntf.INTEREST_CAR
      : interest.ntf.INTEREST_MOTORBIKE;
    let interestPerYear = findInterestTF(
      interest.tf.INTEREST_TF,
      form.year,
      form.period
    );

    if (form.category === "NTF") {
      return calculatePayPerMonth(
        calamount,
        form.raw_interest,
        form.period,
        form.category
      );
    }

    // interestPerYear = round(
    //   getInterestReduction(calamount, interestPerYear, form.period),
    //   2
    // );

    let payPerMonth = calculatePayPerMonthPerYear(
      calamount,
      // interestPerYear.interest_tf,
      form.raw_interest,
      form.period
    );

    return payPerMonth;
  };

  const getPayPerMonth = () => {
    const calamount = form?.amount;

    const interestNTF = ["CAR", "TRUCK"].includes(form.type)
      ? interest.ntf.INTEREST_CAR
      : interest.ntf.INTEREST_MOTORBIKE;
    let interestPerYear = findInterestTF(
      interest.tf.INTEREST_TF,
      form.year,
      form.period
    );

    if (form.category === "NTF") {
      return calculatePayPerMonth(
        calamount,
        // form?.stop_recal_interest === "true" ? form?.interest : interestNTF,
        form?.raw_interest,
        form.period,
        form.category0
      );
    }

    // interestPerYear = round(
    //   getInterestReduction(calamount, interestPerYear, form.period),
    //   2
    // );

    let payPerMonth = calculatePayPerMonthPerYear(
      calamount,
      form.raw_interest,
      form.period
    );

    return roundUp(payPerMonth + payPerMonth * 0.07, 0);
  };

  const getType = () => {
    if (leasing_request?.type === "MOTORBIKE") {
      return "รถจักรยานยนต์";
    }
    // else if (leasing_request?.type === "CAR") {
    //   return "รถยนต์";
    // }
    return "รถยนต์";
  };

  const getCanEdit = () => {
    if (
      [
        "รับคำร้อง",
        "รอติดต่อบุคคลอ้างอิง",
        "รอนัดหมาย",
        "นัดหมายแล้ว",
        "งานสำเร็จแล้ว",
      ].includes(leasing_request?.loan_status)
    ) {
      return user?.username === form?.reserveBy;
    }
    return false;
  };

  const onClickSaveEditGrt = async () => {
    try {
      setLoadingSaveGrt(true);
      const keys = Object.keys(form);
      const formGrt = {};

      for (const key of keys) {
        if (String(key).indexOf("Grt") > -1) {
          formGrt[key] = form[key];
        }
      }

      await API.put("MoneyHubAdmin", `/leasing/infomation/${form.request_id}`, {
        body: {
          ...leasing_request,
          ...getConvertRequest(form),
          ...formGrt,
          guarantorType: form?.guarantorType,
          fileBuro: leasing_request?.ori_fileBuro,
          pdpaUri: leasing_request?.ori_pdpaUri,
        },
      });
      await API.post(
        "MoneyHubAdmin",
        `/leasing/histories/${leasing_request.request_id}`,
        {
          body: {
            ...form,
            action: "บุคคลค้ำประกัน",
            fileBuro: leasing_request?.ori_fileBuro,
            pdpaUri: leasing_request?.ori_pdpaUri,
            adminName: user.username,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS");
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSaveGrt(false);
    }
  };

  const getBurdenSum = () => {
    if (!form?.dataDebt?.length) return 0;
    const burdenSum = form?.dataDebt?.reduce((acc, cur) => {
      return acc + Number(cur?.payperinsallment);
    }, 0);
    return burdenSum;
  };

  const getTotalAmount = () => {
    const vat = form?.vat || 0;
    return getPayPerMonth() * form.period;
  };

  if (firstLoad) {
    return <LoadingPage />;
  }

  const information = getInformationTF(form);

  if (openModal) {
    return (
      <div
        show={openModal}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <HistoriesModalTable
          openModalHistories={openModalHistories}
          setOpenModalHistories={setOpenModalHistories}
          histories={histories}
        />
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className=" h-screen  pb-20 text-center sm:p-0">
            <div className="flex-1 bg-green-500"></div>
            <div className="flex-1 bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-0  h-screen  w-full ">
              {loadingId ? (
                <LoadingPage />
              ) : (
                <div className=" flex flex-col justify-between min-h-screen">
                  <div className="mx-4 pt-5 pb-4 sm:p-6 sm:pb-4 flex-1   ">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full ">
                      <HeaderModal
                        loadingHistories={loadingHistories}
                        onClickHistory={onClickHistory}
                        leasing_request={leasing_request}
                        form={form}
                      />
                      <div
                        className={
                          "mt-2 overflow-auto  md:min-h-screen-80   h-450-px    grid grid-cols-1 lg:grid-cols-3 gap-1"
                        }
                      >
                        <BoxContent>
                          <Title title={"ข้อมูลสินเชื่อ"} />
                          <Content
                            title={"ประเภท"}
                            value={leasing_request?.purpose}
                          />

                          <Content
                            title={"ราคากลาง"}
                            value={numeral(leasing_request?.value).format(
                              "0,000"
                            )}
                          />

                          {/* {form?.year !== temp?.year ||
                          form?.subModel !== temp?.subModel ? (
                            <TextInput
                              label={"ราคากลาง"}
                              value={form?.value}
                              name="value"
                              type="number"
                              min={0}
                              onChange={onChangeForm}
                              required
                              // customenRequired={form.amount > getPriceLTV()}
                              // errorMessage={
                              //   form.amount > getPriceLTV()
                              //     ? "วงเงินที่ได้รับต้องไม่เกินยอด LTV"
                              //     : "โปรดกรอกข้อมูล"
                              // }
                            />
                          ) : (
                            <Content
                              title={"ราคากลาง"}
                              value={numeral(leasing_request?.value).format(
                                "0,000"
                              )}
                            />
                          )} */}
                          <Content
                            title={"ค่าประเมิน LTV"}
                            value={numeral(getPriceLTV()).format("0,000")}
                          />

                          {form?.category === "NTF" &&
                            form?.type === "MOTORBIKE" &&
                            [
                              {
                                label: "ค่าอากรแสตมป์",
                                name: "stamp",
                                nameDropdown: "stamp_dropdown",
                              },
                              {
                                label: "ค่าธรรมเนียมการใช้วงเงินสินเชื่อ",
                                name: "fee_motorbike",
                                nameDropdown: "fee_motorbike_dropdown",
                              },
                            ].map((item) => {
                              return (
                                <div className="flex flex-col">
                                  <Content title={item?.label} value={""} />
                                  <div className="ml-4 flex items-center">
                                    <div className="mr-2">-</div>
                                    <SelectInput
                                      label={""}
                                      value={{
                                        label: form[item?.nameDropdown],
                                        value: form[item?.nameDropdown],
                                      }}
                                      name={item.nameDropdown}
                                      onChangeSelect={onChangeSelect}
                                      options={FEE_OPTIONS}
                                    />
                                  </div>
                                  {form[item.nameDropdown] === "เรียกเก็บ" && (
                                    <div className="ml-4 flex flex-col">
                                      <div className="flex items-center">
                                        <div className="mr-2">-</div>
                                        <Content
                                          className="ml-2"
                                          value={`${form[item.name]}%`}
                                        />
                                      </div>
                                      <div className="flex items-center">
                                        <div className="mr-2">-</div>
                                        <Content
                                          className="ml-2"
                                          value={numeral(
                                            form?.amount *
                                              (form[item?.name] / 100)
                                          ).format("0,000")}
                                        />
                                      </div>
                                      {/* {item?.name !== "stamp" && (
                                        <div className="flex items-center">
                                          <div className="mr-2">-</div>
                                          <Content
                                            className="ml-2"
                                            value={numeral(
                                              form?.amount *
                                                (form[item?.name] / 100) *
                                                0.07
                                            ).format("0,000")}
                                          />
                                          <div className="ml-1">
                                            ภาษีมูลค่าเพิ่ม
                                          </div>
                                        </div>
                                      )} */}
                                    </div>
                                  )}
                                </div>
                              );
                            })}

                          {form?.category === "NTF" &&
                            ["CAR", "TRUCK"].includes(form?.type) &&
                            [
                              {
                                label: "ค่าอากรแสตมป์",
                                name: "stamp",
                                nameDropdown: "stamp_dropdown",
                              },
                              {
                                label: "ค่าธรรมเนียมการประเมินราคารถยนต์",
                                name: "estimate_car",
                                nameDropdown: "estimate_car_dropdown",
                              },
                            ].map((item) => {
                              return (
                                <div className="flex flex-col">
                                  <Content title={item?.label} value={""} />
                                  <div className="ml-4 flex items-center">
                                    <div className="mr-2">-</div>
                                    <SelectInput
                                      label={""}
                                      value={{
                                        label: form[item?.nameDropdown],
                                        value: form[item?.nameDropdown],
                                      }}
                                      name={item.nameDropdown}
                                      onChangeSelect={onChangeSelect}
                                      options={FEE_OPTIONS}
                                    />
                                  </div>
                                  {form[item.nameDropdown] === "เรียกเก็บ" && (
                                    <div className="ml-4 flex flex-col">
                                      <div className="flex items-center">
                                        <div className="mr-2">-</div>
                                        <Content
                                          className="ml-2"
                                          value={`${form[item.name]}%`}
                                        />
                                      </div>
                                      <div className="flex items-center">
                                        <div className="mr-2">-</div>
                                        <Content
                                          className="ml-2"
                                          value={numeral(
                                            form?.amount *
                                              (form[item?.name] / 100)
                                          ).format("0,000")}
                                        />
                                      </div>
                                      {/* {item?.name !== "stamp" && (
                                        <div className="flex items-center">
                                          <div className="mr-2">-</div>
                                          <Content
                                            className="ml-2"
                                            value={numeral(
                                              form?.amount *
                                                (form[item?.name] / 100) *
                                                0.07
                                            ).format("0,000")}
                                          />
                                          <div className="ml-1">
                                            ภาษีมูลค่าเพิ่ม
                                          </div>
                                        </div>
                                      )} */}
                                    </div>
                                  )}
                                </div>
                              );
                            })}

                          {/* MARK_FEE */}
                          {form?.category === "TF" &&
                            ["CAR", "TRUCK"].includes(form?.type) &&
                            [
                              {
                                label: "ค่าอากรแสตมป์",
                                name: "stamp",
                                nameDropdown: "stamp_dropdown",
                              },
                              {
                                label: "ค่าธรรมเนียมการประเมินราคารถยนต์",
                                name: "estimate_car",
                                nameDropdown: "estimate_car_dropdown",
                              },
                              {
                                label: "ค่าตรวจสภาพรถ",
                                name: "fee_inspection",
                                nameDropdown: "fee_inspection_dropdown",
                              },
                              {
                                label: "ค่าโอนทะเบียนกรรมสิทธิ์",
                                name: "fee_transfer",
                                nameDropdown: "fee_transfer_dropdown",
                              },
                              {
                                label: "ค่าบริการ",
                                name: "fee_service",
                                nameDropdown: "fee_service_dropdown",
                              },
                            ].map((item) => {
                              return (
                                <div className="flex flex-col">
                                  <Content title={item?.label} value={""} />
                                  <div className="ml-4 flex items-center">
                                    <div className="mr-2">-</div>
                                    <SelectInput
                                      label={""}
                                      value={{
                                        label: form[item?.nameDropdown],
                                        value: form[item?.nameDropdown],
                                      }}
                                      name={item.nameDropdown}
                                      onChangeSelect={onChangeSelect}
                                      options={FEE_OPTIONS}
                                    />
                                  </div>
                                  {form[item.nameDropdown] === "เรียกเก็บ" &&
                                    ([
                                      "ค่าอากรแสตมป์",
                                      "ค่าธรรมเนียมการประเมินราคารถยนต์",
                                      "ค่าธรรมเนียมการใช้วงเงินสินเชื่อ",
                                    ].includes(item?.label) ? (
                                      <div className="ml-4 flex flex-col">
                                        <div className="flex items-center">
                                          <div className="mr-2">-</div>
                                          <Content
                                            className="ml-2"
                                            value={`${form[item.name]}%`}
                                          />
                                        </div>
                                        <div className="flex items-center">
                                          <div className="mr-2">-</div>
                                          <Content
                                            className="ml-2"
                                            value={numeral(
                                              form?.amount *
                                                (form[item?.name] / 100)
                                            ).format("0,000")}
                                          />
                                        </div>
                                        {item.name !== "stamp" && (
                                          <div className="flex items-center">
                                            <div className="mr-2">-</div>
                                            <Content
                                              className="ml-2"
                                              value={numeral(
                                                form?.amount *
                                                  (form[item?.name] / 100) *
                                                  0.07
                                              ).format("0,000")}
                                            />
                                            <div className="ml-1">
                                              ภาษีมูลค่าเพิ่ม
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="ml-4 flex flex-col">
                                        <div className="flex items-center">
                                          <div className="mr-2">-</div>
                                          <TextInput
                                            label={""}
                                            value={form[item?.name]}
                                            name={item?.name}
                                            onChange={onChangeForm}
                                            options={FEE_OPTIONS}
                                            className="w-12"
                                            type="text"
                                          />
                                        </div>
                                        {["fee_service"].includes(
                                          item?.name
                                        ) && (
                                          <div className="flex items-center mt-2">
                                            <div className="mr-2">-</div>
                                            <Content
                                              className="ml-5"
                                              value={numeral(
                                                form[item?.name] * 0.07
                                              ).format("0,000")}
                                            />
                                            <div className="ml-1">
                                              ภาษีมูลค่าเพิ่ม
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              );
                            })}

                          {/* {getFeeDropDown(form).map((item, index) => {
                            return (
                              <Content
                                title={item.label}
                                value={numeral(String(item.value)).format(
                                  "0,000"
                                )}
                              />
                            );
                          })} */}

                          {/* <Content
                            title={"วงเงินที่ได้รับหลังหักค่าใช้จ่าย"}
                            value={numeral(
                              getRequestAmountAfter(form, getFeeDropDown(form))
                            ).format("0,000")}
                          /> */}

                          <SelectInput
                            label={"LTV"}
                            value={{
                              label: form?.ltv,
                              value: form?.ltv,
                            }}
                            name="ltv"
                            onChangeSelect={onChangeSelect}
                            options={getLtvOptions()}
                            required={checkClickSubmit && !form?.ltv}
                            // !form.ltv && form?.loan_status === "งานสำเร็จแล้ว"
                            // }
                          />

                          <TextInput
                            label={`วงเงินที่บริษัทประเมิน LTV`}
                            value={Number(form.requestamount).toLocaleString()}
                            // value={form.requestamount}
                            name="requestamount"
                            type="text"
                            min={0}
                            onChange={onChangeForm}
                            required={checkClickSubmit && !form?.requestamount}
                            // customenRequired={
                            //   // form?.loan_status === "งานสำเร็จแล้ว" &&
                            //   form.requestamount > getPriceLTV()
                            // }
                            // errorMessage={
                            //   // form?.loan_status === "งานสำเร็จแล้ว" &&
                            //   form.requestamount > getPriceLTV()
                            //     ? "วงเงินที่ได้รับต้องไม่เกินยอด LTV"
                            //     : "โปรดกรอกข้อมูล"
                            // }
                            // customenRequired={Number(form?.requestamount) === 0}
                          />

                          <TextInput
                            label={`วงเงินที่ขอ/ทีมพิจารณาอนุมัติ`}
                            // label2={numeral(form?.amount).format("0,000")}
                            // value={Number(form.amount).toLocaleString()}
                            value={Number(form.amount).toLocaleString()}
                            name="amount"
                            type="text"
                            min={0}
                            max={getPriceLTV()}
                            onChange={onChangeForm}
                            required
                            customenRequired={
                              form?.amount > form?.requestamount
                            }
                            errorMessage={
                              form?.amount > form?.requestamount
                                ? "วงที่ขอต้องไม่เกินวงที่ได้รับ"
                                : ""
                            }
                          />

                          <SelectInput
                            label={"งวด"}
                            value={{
                              label: form?.period,
                              value: Number(form.period),
                            }}
                            name="period"
                            onChangeSelect={onChangeSelect}
                            options={[
                              { label: "12", value: 12 },
                              { label: "24", value: 24 },
                              { label: "36", value: 36 },
                              { label: "48", value: 48 },
                              { label: "60", value: 60 },
                            ]}
                          />

                          <Content
                            title={"ผ่อนต่อเดือน"}
                            value={numeral(getPayPerMonth()).format("0,000")}
                            textColor="text-black"
                          />

                          {getCanEdit() && (
                            <button
                              disabled={loadingInformation}
                              className={classNames(
                                " text-white px-2 py-1 rounded text-sm cursor-pointer ml-0 mt-1 mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed":
                                    loadingInformation,
                                  "bg-green-500 cursor-pointer":
                                    !loadingInformation,
                                }
                              )}
                              onClick={onClickSaveInformation}
                              // onClick={onClickAddDebt}
                            >
                              {loadingInformation ? "กำลังบันทึก..." : "บันทึก"}
                            </button>
                          )}

                          <div className="w-full p-3 my-2 text-gray-500 rounded-sm border border-gray-200 bg-gray-50">
                            {/* <Content
                              title={"ธนาคาร"}
                              value={form?.bank}
                              textColor="text-gray-700"
                            /> */}
                            <SelectInput
                              label={"ธนาคาร"}
                              value={{
                                label: form?.bank,
                                value: form?.bank,
                              }}
                              name="bank"
                              onChangeSelect={onChangeSelect}
                              options={BANK_OPTIONS}
                              width="w-56"
                            />
                            <TextInput
                              label={"เลขที่บัญชี"}
                              value={form?.bankNo}
                              name="bankNo"
                              type="text"
                              onChange={onChangeForm}
                              required={checkClickSubmit && !form?.bankNo}
                            />

                            <TextInput
                              label={"ชื่อบัญชี"}
                              value={form.bankAccName}
                              name="bankAccName"
                              type="text"
                              onChange={onChangeForm}
                              required={checkClickSubmit && !form?.bankAccName}
                            />

                            <div>
                              {isTransfer ? (
                                <Content
                                  title={"รหัสสาขา"}
                                  value={leasing_request?.bankBrachCode}
                                />
                              ) : (
                                <React.Fragment>
                                  <div className="text-gray-700">รหัสสาขา</div>
                                  <Input
                                    value={form?.bankBrachCode}
                                    maxLength={4}
                                    type="text"
                                    name="bankBrachCode"
                                    onChange={onChangeForm}
                                  />
                                  {!form.bankBrachCode && checkClickSubmit && (
                                    <span
                                      id={`required_bankBrachCode`}
                                      className="text-red-400"
                                    >
                                      โปรดกรอกรหัสสาขา
                                    </span>
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                            {getCanEdit() && (
                              <button
                                disabled={loadingBank}
                                className={classNames(
                                  " text-white px-2 py-1 rounded text-sm cursor-pointer mt-2 mb-1",
                                  {
                                    "bg-gray-600 cursor-not-allowed":
                                      loadingBank,
                                    "bg-green-500 cursor-pointer": !loadingBank,
                                  }
                                )}
                                onClick={onClickSaveBank}
                                // onClick={onClickAddDebt}
                              >
                                {loadingBank ? "กำลังบันทึก..." : "บันทึก"}
                              </button>
                            )}
                          </div>

                          <Content
                            title={"สิทธิพิเศษ"}
                            value={
                              leasing_request?.privillege == ""
                                ? ""
                                : leasing_request?.privillegeType +
                                  " " +
                                  leasing_request?.privillege
                            }
                          />

                          {leasing_request?.promo !== 0 &&
                            typeof leasing_request?.promo !== "undefined" && (
                              <div className="w-full p-3 mt-2 text-green-500 rounded-sm border border-green-200 bg-green-50">
                                ได้รับส่วนลดดอกเบี้ย: {leasing_request?.promo} %
                              </div>
                            )}

                          {leasing_request?.refinance_kbank_id !== undefined &&
                            leasing_request?.refinance_kbank_id !== "" && (
                              <div className="w-full p-3 mt-2 text-blue-500 rounded-sm border border-blue-200 bg-blue-50">
                                รีไฟแนนซ์มาจาก:{" "}
                                {leasing_request?.refinance_kbank_id}
                              </div>
                            )}

                          {!true && (
                            <div className="my-3 w-full">
                              วันที่ยืนยัน (ใช้สำหรับ test)
                              <input
                                // max={getCurrentLocalDateTime(new Date()).fullDate}
                                defaultValue={
                                  form?.mockConfirmDate &&
                                  form?.mockConfirmDate !== "-"
                                    ? format(
                                        new Date(form?.mockConfirmDate),
                                        "yyyy-MM-dd"
                                      )
                                    : ""
                                }
                                name="mockConfirmDate"
                                className="border boder-gray-300 p-2 ml-4"
                                type="date"
                                onChange={onChangeForm}
                              />
                            </div>
                          )}

                          {isTransfer && (
                            <div className="my-3 w-full">
                              วันที่โอนเงิน
                              <input
                                // max={
                                //   getCurrentLocalDateTime(new Date()).fullDate
                                // }
                                defaultValue={format(
                                  new Date(form.transferDate),
                                  "yyyy-MM-dd"
                                )}
                                name="transferDate"
                                className="border boder-gray-300 p-2 ml-4"
                                type="date"
                                onChange={onChangeForm}
                              />
                            </div>
                          )}

                          {leasing_request?.tx ? (
                            <Content
                              title="Tx (เลขอ้างอิงการโอนงิน)"
                              value={leasing_request?.tx}
                              textColor={"text-green-600"}
                            />
                          ) : (
                            leasing_request?.loan_status === "ยืนยัน" && (
                              <div className="flex flex-col text-gray-700">
                                Tx (เลขอ้างอิงการโอนงิน)
                                <input
                                  onChange={onChangeForm}
                                  className="border py-1 px-2 border-blue-200"
                                  type="text"
                                  name="tx"
                                />
                                {error && !form.tx && (
                                  <span className="text-red-400 text-sm">
                                    โปรดกรอกเลขอ้างอิงการโอนงิน
                                  </span>
                                )}
                              </div>
                            )
                          )}

                          {leasing_request?.loan_status ===
                          "อนุมัติ" ? null : leasing_request?.loan_status ===
                              "ไม่ผ่าน" || isTransfer ? (
                            <div className="my-3 w-full">
                              <Content
                                title={"เหตุผลในการปฏิเสธ"}
                                value={leasing_request?.reason || "-"}
                              />
                            </div>
                          ) : (
                            <React.Fragment>
                              <div>เหตุผลในการปฎิเสธ</div>
                              <br />
                              <textarea
                                name="reason"
                                onChange={onChangeForm}
                                value={form.reason}
                                type="text"
                                rows={3}
                                placeholder="เหตุผลในการปฎิเสธ"
                                className="px-3 -mt-3 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                              />
                              {status === "รอผู้ยื่นคำร้องแก้ไข" &&
                                error &&
                                !form.reason && (
                                  <span className=" text-red-500">
                                    โปรดกรอกเหตุผลในการปฏิเสธ
                                  </span>
                                )}
                              <div>
                                <div className="flex flex-col">
                                  {oriAttachments.length > 0 &&
                                    oriAttachments.map(
                                      (oriAttachment, index) => {
                                        return (
                                          <div className="flex space-x-1 items-center">
                                            <a
                                              href={oriAttachment.link}
                                              className="text-blue-500 mr-2"
                                            >
                                              {oriAttachment.name}
                                            </a>
                                            <div
                                              className="text-sm text-red-400 cursor-pointer"
                                              onClick={() =>
                                                onDeleteAttachment(index)
                                              }
                                            >
                                              ลบ
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                </div>
                                <div className="mr-2 font-bold text-gray-700 text-base mb-2">
                                  แนบไฟล์
                                </div>
                                {/* {!form.attachments.length &&
                                  checkClickSubmit && (
                                    <span
                                      id={`required_attachments`}
                                      className="text-red-400"
                                    >
                                      โปรดแนบไฟล์
                                    </span>
                                  )} */}
                                <input
                                  type="file"
                                  name="attachments"
                                  multiple="multiple"
                                  onChange={onChangeAttachment}
                                  ref={fileRef}
                                />
                                <div className="my-2">
                                  {form?.attachmentViews.length > 0 &&
                                    form?.attachmentViews.map(
                                      (attachmentView) => {
                                        return (
                                          <div>{attachmentView?.name}</div>
                                        );
                                      }
                                    )}
                                </div>

                                <button
                                  disabled={loadingSaveAttchment || !checkEdit}
                                  onClick={onSaveAttachment}
                                  className={classNames("px-2 py-1  rounded ", {
                                    "bg-green-500 cursor-pointer text-white":
                                      !loadingSaveAttchment || checkEdit,
                                    "bg-gray-400 cursor-not-allowed":
                                      loadingSaveAttchment || !checkEdit,
                                  })}
                                >
                                  {loadingSaveAttchment
                                    ? "กำลังบันทึกไฟล์"
                                    : "บันทึกไฟล์"}
                                </button>
                              </div>
                            </React.Fragment>
                          )}

                          <div className="border-b border-gray-300 mb-4 mt-2"></div>
                          <Title title="บุคคลค้ำประกัน" />
                          <SelectInput
                            label="เลือกบุคคลค้ำประกัน"
                            options={GURANTOR_OPTIONS}
                            onChangeSelect={onChangeSelect}
                            value={{
                              label: form?.guarantorType,
                              value: form?.guarantorType,
                            }}
                            name="guarantorType"
                          />
                          <div className="mt-3"></div>

                          {form?.guarantorType &&
                            form?.guarantorType === "มีผู้ค้ำประกัน" && (
                              <>
                                <SelectInput
                                  label={"คำนำหน้านาม"}
                                  value={{
                                    label: form?.articleGrt,
                                    value: form?.articleGrt,
                                  }}
                                  name="articleGrt"
                                  onChangeSelect={onChangeSelect}
                                  options={[
                                    { label: "นาย", value: "นาย" },
                                    { label: "นาง", value: "นาง" },
                                    { label: "นางสาว", value: "นางสาว" },
                                  ]}
                                  width="w-28"
                                  required={
                                    checkClickSubmit && !form.articleGrt
                                  }
                                />
                                <TextInput
                                  label={"ชื่อ"}
                                  value={form.nameGrt}
                                  name="nameGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-36"
                                  required={checkClickSubmit && !form.nameGrt}
                                />
                                <TextInput
                                  label={"นามสกุล"}
                                  value={form.lastnameGrt}
                                  name="lastnameGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-36"
                                  required={
                                    checkClickSubmit && !form.lastnameGrt
                                  }
                                />
                                <TextInput
                                  label={"ชื่อเล่น"}
                                  value={form.nicknameGrt}
                                  name="nicknameGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-18"
                                  required={
                                    checkClickSubmit && !form.nicknameGrt
                                  }
                                />

                                <TextInput
                                  label={"บัตรประชาชน"}
                                  value={form.citizenidGrt}
                                  name="citizenidGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-18"
                                  maxLength={13}
                                  required={
                                    checkClickSubmit && !form.citizenidGrt
                                  }
                                  customenRequired={
                                    form?.citizenidGrt?.length !== 13 &&
                                    form?.citizenidGrt?.length > 0 &&
                                    checkClickSubmit
                                  }
                                  errorMessage={
                                    form.citizenidGrt?.length !== 13 &&
                                    form?.citizenidGrt?.length > 0 &&
                                    checkClickSubmit
                                      ? "กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก"
                                      : ""
                                  }
                                  // required
                                />

                                <TextInput
                                  label={"รหัสหลังบัตร"}
                                  value={form?.hashCitizenGrt}
                                  name="hashCitizenGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-18"
                                  required={
                                    checkClickSubmit && !form.hashCitizenGrt
                                  }
                                  customenRequired={
                                    form?.hashCitizenGrt?.length > 0 &&
                                    form?.hashCitizenGrt?.length !== 14 &&
                                    checkClickSubmit
                                  }
                                  errorMessage={
                                    form?.hashCitizenGrt?.length > 0 &&
                                    form?.hashCitizenGrt?.length !== 14 &&
                                    checkClickSubmit
                                      ? "กรุณากรอกรหัสหลังบัตร"
                                      : ""
                                  }
                                  // required
                                />

                                <DateInput
                                  label={"วันหมดอายุบัตร"}
                                  value={form?.citizenexpiredateGrt}
                                  name="citizenexpiredateGrt"
                                  onChange={onChangeFormDate}
                                  width="w-18"
                                  required={
                                    checkClickSubmit &&
                                    !form?.citizenexpiredateGrt
                                  }
                                  // customenRequired={form?.citizenexpiredateGrt }
                                />

                                <SelectInput
                                  label={"เพศ"}
                                  value={{
                                    label: form?.genderGrt,
                                    value: form?.genderGrt,
                                  }}
                                  name="genderGrt"
                                  onChangeSelect={onChangeSelect}
                                  options={[
                                    { label: "ชาย", value: "ชาย" },
                                    { label: "หญิง", value: "หญิง" },
                                  ]}
                                />

                                <DateInput
                                  label={"วัน/เดือน/ปี เกิด"}
                                  value={form?.birthdateThGrt}
                                  name="birthdateThGrt"
                                  onChange={onChangeFormDate}
                                  width="w-18"
                                  // customenRequired
                                  required={
                                    checkClickSubmit && !form?.birthdateThGrt
                                  }
                                />

                                <Content
                                  title="อายุ"
                                  value={getAge("birthdateThGrt") || 0}
                                />

                                <SelectInput
                                  label={"สถานภาพ"}
                                  value={{
                                    label: form?.marritalStatusGrt,
                                    value: form?.marritalStatusGrt,
                                  }}
                                  name="marritalStatusGrt"
                                  onChangeSelect={onChangeSelect}
                                  options={[
                                    { label: "โสด", value: "โสด" },
                                    { label: "สมรส", value: "สมรส" },
                                    { label: "หย่าร้าง", value: "หย่าร้าง" },
                                  ]}
                                  width="w-24"
                                  required={
                                    checkClickSubmit && !form?.marritalStatusGrt
                                  }
                                />

                                {form?.marritalStatusGrt === "สมรส" && (
                                  <React.Fragment>
                                    <SelectInput
                                      label={"คำนำหน้านาม (คู่สมรส)"}
                                      value={{
                                        label: form?.articlePartnerGrt,
                                        value: form?.articlePartnerGrt,
                                      }}
                                      name="articlePartnerGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={[
                                        { label: "นาย", value: "นาย" },
                                        { label: "นาง", value: "นาง" },
                                        { label: "นางสาว", value: "นางสาว" },
                                      ]}
                                      width="w-28"
                                      required={
                                        checkClickSubmit &&
                                        !form?.articlePartnerGrt
                                      }
                                    />
                                    <TextInput
                                      label={"ชื่อ (คู่สมรส)"}
                                      value={form.namePartnerGrt}
                                      name="namePartnerGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-36"
                                      required={
                                        checkClickSubmit &&
                                        !form?.namePartnerGrt
                                      }
                                    />
                                    <TextInput
                                      label={"นามสกุล (คู่สมรส)"}
                                      value={form.lastnamePartnerGrt}
                                      name="lastnamePartnerGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-36"
                                      required={
                                        checkClickSubmit &&
                                        !form?.lastnamePartnerGrt
                                      }
                                    />
                                    <TextInput
                                      label={"เบอร์โทรศัพท์ (คู่สมรส)"}
                                      value={form.phoneNumberPartnerGrt}
                                      name="phoneNumberPartnerGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-36"
                                      // required
                                    />
                                  </React.Fragment>
                                )}

                                <SelectInput
                                  label={"การศึกษา"}
                                  value={{
                                    label: form?.educationGrt,
                                    value: form?.educationGrt,
                                  }}
                                  name="educationGrt"
                                  onChangeSelect={onChangeSelect}
                                  options={[
                                    {
                                      label: "ม.3 หรือน้อยกว่า",
                                      value: "ม.3 หรือน้อยกว่า",
                                    },
                                    {
                                      label: "ม.6 / ปวช.",
                                      value: "ม.6 / ปวช.",
                                    },
                                    { label: "ปวส.", value: "ปวส." },
                                    { label: "ปริญญาตรี", value: "ปริญญาตรี" },
                                    {
                                      label: "สูงกว่าปริญญาตรี",
                                      value: "สูงกว่าปริญญาตรี",
                                    },
                                  ]}
                                  width="w-40"
                                  required={
                                    checkClickSubmit && !form?.educationGrt
                                  }
                                />

                                <div className="mt-2 mb-2">
                                  <TextInput
                                    label={"เบอร์โทรศัพท์"}
                                    value={form?.phone_numberGrt}
                                    name="phone_numberGrt"
                                    type="phone_numberGrt"
                                    onChange={onChangeForm}
                                    width="w-42"
                                    maxLength={10}
                                    customenRequired={
                                      form?.phone_numberGrt?.length > 0 &&
                                      form?.phone_numberGrt?.length !== 10 &&
                                      checkClickSubmit
                                    }
                                    errorMessage={
                                      form?.phone_numberGrt?.length > 0 &&
                                      form?.phone_numberGrt?.length !== 10 &&
                                      checkClickSubmit &&
                                      "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก"
                                    }
                                    required={
                                      checkClickSubmit && !form?.phone_numberGrt
                                    }
                                  />
                                  {/* <Content
                              title="เบอร์โทรศัพท์"
                              value={leasing_request?.phone_numberGrt}
                            /> */}
                                </div>

                                <TextInput
                                  label={"อีเมล"}
                                  value={form?.emailGrt}
                                  name="emailGrt"
                                  type="email"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={checkClickSubmit && !form?.emailGrt}
                                />

                                <TextInput
                                  label={"ไลน์ไอดี"}
                                  value={form?.lineidGrt}
                                  name="lineidGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  // required={checkClickSubmit && !form?.lineidGrt}
                                />

                                <div className="mt-2">
                                  <div className={"text-gray-700 mr-auto"}>
                                    ที่อยู่ตามทะเบียนบ้าน :
                                  </div>
                                  <div className="flex flex-col">
                                    <TextInput
                                      label={"บ้านเลขที่"}
                                      value={form?.addressCodeGrt}
                                      name="addressCodeGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-42"
                                      required={
                                        checkClickSubmit &&
                                        !form?.addressCodeGrt
                                      }
                                    />
                                    <TextInput
                                      label={"อาคาร/หมู่บ้าน/ซอย"}
                                      value={form?.addressDescGrt}
                                      name="addressDescGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-56"
                                      required={
                                        checkClickSubmit &&
                                        !form?.addressDescGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"จังหวัด"}
                                      value={{
                                        label: form?.addressProvinceGrt,
                                        value: form?.addressProvinceGrt,
                                      }}
                                      name="addressProvinceGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={provinces.map((province) => {
                                        return {
                                          label: province,
                                          value: province,
                                        };
                                      })}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.addressProvinceGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"เขต"}
                                      value={{
                                        label: form?.addressDistrictGrt,
                                        value: form?.addressDistrictGrt,
                                      }}
                                      name="addressDistrictGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={districtGrt.map((district) => {
                                        return {
                                          label: district,
                                          value: district,
                                        };
                                      })}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.addressDistrictGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"แขวง"}
                                      value={{
                                        label: form?.addressSubDistrictGrt,
                                        value: form?.addressSubDistrictGrt,
                                      }}
                                      name="addressSubDistrictGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={subDistrictGrt.map(
                                        (district) => {
                                          return {
                                            label: district?.value,
                                            value: district?.value,
                                            ...district,
                                          };
                                        }
                                      )}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.addressSubDistrictGrt
                                      }
                                    />
                                    <Content
                                      title="รหัสไปรษณีย์"
                                      value={form?.addressSubDistrictGrtZipCode}
                                    />
                                  </div>
                                </div>

                                <div className="mt-2">
                                  <div className={"text-gray-700 mr-auto"}>
                                    ที่อยู่ปัจจุบัน :
                                  </div>
                                  <div className="flex flex-col">
                                    <TextInput
                                      label={"บ้านเลขที่"}
                                      value={form?.officialAddressCodeGrt}
                                      name="officialAddressCodeGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-42"
                                      required={
                                        checkClickSubmit &&
                                        !form?.officialAddressCodeGrt
                                      }
                                    />
                                    <TextInput
                                      label={"อาคาร/หมู่บ้าน/ซอย"}
                                      value={form?.officialAddressDescGrt}
                                      name="officialAddressDescGrt"
                                      type="text"
                                      onChange={onChangeForm}
                                      width="w-56"
                                      required={
                                        checkClickSubmit &&
                                        !form?.officialAddressDescGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"จังหวัด"}
                                      value={{
                                        label: form?.currentAddressProvinceGrt,
                                        value: form?.currentAddressProvinceGrt,
                                      }}
                                      name="currentAddressProvinceGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={provinces.map((province) => {
                                        return {
                                          label: province,
                                          value: province,
                                        };
                                      })}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.currentAddressProvinceGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"เขต"}
                                      value={{
                                        label: form?.currentAddressDistrictGrt,
                                        value: form?.currentAddressDistrictGrt,
                                      }}
                                      name="currentAddressDistrictGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={currentDistrictGrt.map(
                                        (district) => {
                                          return {
                                            label: district,
                                            value: district,
                                          };
                                        }
                                      )}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.currentAddressDistrictGrt
                                      }
                                    />
                                    <SelectInput
                                      label={"แขวง"}
                                      value={{
                                        label:
                                          form?.currentAddressSubDistrictGrt,
                                        value:
                                          form?.currentAddressSubDistrictGrt,
                                      }}
                                      name="currentAddressSubDistrictGrt"
                                      onChangeSelect={onChangeSelect}
                                      options={currentSubDistrictGrt.map(
                                        (district) => {
                                          return {
                                            label: district?.value,
                                            value: district?.value,
                                            ...district,
                                          };
                                        }
                                      )}
                                      width="w-40"
                                      required={
                                        checkClickSubmit &&
                                        !form?.currentAddressSubDistrictGrt
                                      }
                                    />
                                    <Content
                                      title="รหัสไปรษณีย์"
                                      value={
                                        form?.currentAddressSubDistrictGrtZipCode
                                      }
                                    />
                                  </div>
                                </div>

                                <SelectInput
                                  label={"อาชีพ"}
                                  value={{
                                    label: form?.careertypeGrt,
                                    value: form?.careertypeGrt,
                                  }}
                                  name="careertypeGrt"
                                  onChangeSelect={onChangeSelect}
                                  options={CAREER_OPTIONS?.map((option) => {
                                    return {
                                      label: option,
                                      value: option,
                                    };
                                  })}
                                  width="w-52"
                                  required={
                                    checkClickSubmit && !form?.careertypeGrt
                                  }
                                />
                                <TextInput
                                  label={"สถานประกอบการ"}
                                  value={form?.companyGrt}
                                  name="companyGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.companyGrt
                                  }
                                />
                                <TextInput
                                  label={"เบอร์โทรสถานประกอบการ"}
                                  value={form?.job_phoneGrt}
                                  name="job_phoneGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.job_phoneGrt
                                  }
                                />
                                <TextInput
                                  label={"ที่อยู่สถานประกอบการ"}
                                  value={form?.job_addressGrt}
                                  name="job_addressGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.job_addressGrt
                                  }
                                />
                                <SelectInput
                                  label={"ตำแหน่งล่าสุด"}
                                  value={{
                                    value: form?.jobpositionGrt,
                                    label: form?.jobpositionGrt,
                                  }}
                                  options={POSITION_OPTIONS}
                                  name="jobpositionGrt"
                                  onChangeSelect={onChangeSelect}
                                  width=" w-60"
                                  required={
                                    checkClickSubmit && !form?.jobpositionGrt
                                  }
                                />

                                <TextInput
                                  label={"รายได้"}
                                  value={form?.incomeGrt}
                                  name="incomeGrt"
                                  min={0}
                                  type="number"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.incomeGrt
                                  }
                                />

                                <TextInput
                                  label={"รายจ่าย"}
                                  value={form?.expenseGrt}
                                  name="expenseGrt"
                                  min={0}
                                  type="number"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.expenseGrt
                                  }
                                />

                                <TextInput
                                  label={"ความสัมพันธ์"}
                                  value={form?.relationGrt}
                                  name="relationGrt"
                                  type="text"
                                  onChange={onChangeForm}
                                  width="w-42"
                                  required={
                                    checkClickSubmit && !form?.relationGrt
                                  }
                                />

                                {/* บันทึกบุคคลค้ำประกัน */}
                                {getCanEdit() && (
                                  <button
                                    disabled={loadingSaveGrt}
                                    className={classNames(
                                      " text-white px-2 py-1 rounded text-sm cursor-pointer ml-1 mb-1",
                                      {
                                        "bg-gray-600 cursor-not-allowed":
                                          loadingSaveGrt,
                                        "bg-green-500 cursor-pointer":
                                          !loadingSaveGrt,
                                      }
                                    )}
                                    onClick={onClickSaveEditGrt}
                                    // onClick={onClickAddDebt}
                                  >
                                    {loadingSaveGrt
                                      ? "กำลังบันทึก..."
                                      : "บันทึก"}
                                  </button>
                                )}
                              </>
                            )}

                          {/* {leasing_request?.tx !== undefined &&
                          leasing_request?.tx !== "" && (
                            <Content
                              title={"Tx (เลขอ้างอิงการโอนงิน)"}
                              value={leasing_request?.tx}
                              textColor="text-green-600"
                            />
                          )} */}
                        </BoxContent>

                        <BoxContent>
                          {leasing_request.category === "TF" ? (
                            <div className="mt-4 mb-3">
                              <h3 className="mb-2 text-blueGray-800 font-black">
                                รายละเอียด
                              </h3>
                              <Content
                                title={`1. วงเงินกู้`}
                                value={numeral(form?.amount).format("0,000")}
                              />
                              {/* <Content
                                title={`รวมยอดกู้`}
                                value={numeral(getTotalAmount()).format(
                                  "0,000"
                                )}
                              /> */}
                              {/* <Content
                                title={`ค่างวดรวม`}
                                value={numeral(getTotalAmount()).format(
                                  "0,000"
                                )}
                              /> */}
                              {/* <Content
                                title={`ภาษีมูลค่าเพิ่ม`}
                                value={numeral(getPayPerMonth() * 0.07).format(
                                  "0,000.00"
                                )}
                              /> */}
                              <Content
                                title={`2. อัตราดอกเบี้ยที่เช่าซื้อเท่ากับอัตราร้อยละ (Flat rate)`}
                                value={`${form.raw_interest}%`}
                              />
                              <Content
                                title={`3. อัตราดอกเบี้ยที่แท้จริง (Effective Interest Rate) เท่ากับอัตราร้อยละ`}
                                value={`${form.interest}%`}
                              />
                              <Content
                                title={`4. จำนวนงวดที่ผ่อนชำระค่าเช่าซื้อ`}
                                value={form.period}
                              />
                              <Content
                                title={`5. รวมจำนวนดอกเบี้ยที่ชำระไม่รวมภาษีมูลค่าเพิ่ม`}
                                value={roundUp(
                                  getTotalInterestNoVat(form),
                                  2
                                ).toLocaleString()}
                              />
                              <Content
                                title={`6. มูลค่าเช่าซื้อไม่รวมภาษีมูลค่าเพิ่ม`}
                                value={round(
                                  getTotalInterestNoVat(form) + form.amount,
                                  2
                                ).toLocaleString()}
                              />
                              <Content
                                title={`7. จำนวนค่างวดเช่าซื้องวดละไม่รวมภาษีมูลค่าเพิ่ม`}
                                value={round(
                                  (getTotalInterestNoVat(form) + form.amount) /
                                    form.period,
                                  2
                                ).toLocaleString()}
                              />
                              <Content
                                title={`8. ค่าภาษีมูลค่าเพิ่ม (7%) สำหรับค่าเช่าซื้อในแต่ละงวด`}
                                value={round(
                                  getPayPerMonthNoVat() * 0.07,
                                  2
                                ).toLocaleString()}
                              />
                              <Content
                                title={`9. จำนวนค่าเช่าซื้อรวมภาษีมูลค่าเพิ่ม งวดละ`}
                                value={`${roundUp(
                                  getPayPerMonth(),
                                  0
                                ).toLocaleString()}`}
                              />
                              <Content
                                title={`10. จำนวนเงินค่าเช่าซื้อรวมภาษีมูลค่าเพิ่มทั้งสิ้น`}
                                value={`${round(
                                  form.period * getPayPerMonth(),
                                  2
                                ).toLocaleString()}`}
                              />
                              <Content
                                title={"11. วงเงินสินเชื่อหลังหักค่าธรรมเนียม"}
                                value={numeral(
                                  Object.keys(form).reduce((prev, curr) => {
                                    if (
                                      form[curr] &&
                                      form[curr] === "เรียกเก็บ"
                                    ) {
                                      const splitCurr = curr
                                        .split("_")
                                        .reduce((prev, curr) => {
                                          if (curr !== "dropdown") {
                                            if (prev) {
                                              return `${prev}_${curr}`;
                                            } else {
                                              return `${curr}`;
                                            }
                                          }
                                          return prev;
                                        }, "");

                                      if (
                                        [
                                          "fee_transfer",
                                          "fee_inspection",
                                        ].includes(splitCurr)
                                      ) {
                                        return (
                                          prev - Number(form[`${splitCurr}`])
                                        );
                                      }

                                      let vat = 0;

                                      if (splitCurr !== "stamp") {
                                        vat =
                                          form?.amount *
                                          (Number(form[`${splitCurr}`]) / 100) *
                                          0.07;
                                      }

                                      if (splitCurr === "fee_service") {
                                        vat =
                                          Number(form[`${splitCurr}`]) * 0.07;

                                        return (
                                          prev -
                                          Number(form[`${splitCurr}`]) -
                                          vat
                                        );
                                      }

                                      return (
                                        prev -
                                        form?.amount *
                                          (Number(form[`${splitCurr}`]) / 100) -
                                        vat
                                      );
                                    }
                                    return prev;
                                  }, form?.amount)
                                ).format("0,000")}
                              />
                              <Content
                                title={`12. กำหนดชำระทุกวันที่`}
                                value={format(
                                  new Date(information?.startDueDate),
                                  "d"
                                )}
                              />
                              <Content
                                title={`13. ชำระงวดแรกวันที่`}
                                value={format(
                                  new Date(information?.startDueDate),
                                  "dd-MM-yyyy"
                                )}
                              />
                            </div>
                          ) : (
                            <div className="mb-3 mt-4">
                              <h3 className="mb-2 text-blueGray-800 font-black">
                                รายละเอียด
                              </h3>
                              <Content
                                title={`1. วงเงินกู้`}
                                value={numeral(form?.amount).format("0,000")}
                              />
                              {/* <Content
                                title={`รวมยอดกู้`}
                                value={numeral(getTotalAmount()).format(
                                  "0,000"
                                )}
                              /> */}
                              {/* <Content
                                title={`ค่างวดรวม`}
                                value={numeral(getTotalAmount()).format(
                                  "0,000"
                                )}
                              />
                              <Content
                                title={`ภาษีมูลค่าเพิ่ม`}
                                value={numeral(0).format("0,000")}
                              /> */}
                              <Content
                                title={`2. กำหนดชำระทุกวันที่`}
                                value={format(
                                  new Date(information?.startDueDate),
                                  "d"
                                )}
                              />
                              <Content
                                title={`3. ชำระงวดแรกวันที่`}
                                value={format(
                                  new Date(information?.startDueDate),
                                  "dd-MM-yyyy"
                                )}
                              />
                              <Content
                                title={"4. วงเงินสินเชื่อหลังหักค่าใช้จ่าย"}
                                value={numeral(
                                  Object.keys(form).reduce((prev, curr) => {
                                    if (
                                      form[curr] &&
                                      form[curr] === "เรียกเก็บ"
                                    ) {
                                      const splitCurr = curr
                                        .split("_")
                                        .reduce((prev, curr) => {
                                          if (curr !== "dropdown") {
                                            if (prev) {
                                              return `${prev}_${curr}`;
                                            } else {
                                              return `${curr}`;
                                            }
                                          }
                                          return prev;
                                        }, "");

                                      let vat = 0;

                                      // if (splitCurr !== "stamp") {
                                      //   vat =
                                      //     form?.amount *
                                      //     (form[`${splitCurr}`] / 100) *
                                      //     0.07;
                                      // }

                                      return (
                                        prev -
                                        form.amount *
                                          (form[`${splitCurr}`] / 100) -
                                        vat
                                      );
                                    }
                                    return prev;
                                  }, form?.amount)
                                ).format("0,000")}
                              />
                              <Content
                                title={"5. ผ่อนชำระต่อเดือน"}
                                value={numeral(getPayPerMonth()).format(
                                  "0,000.00"
                                )}
                              />
                              <Content
                                title={
                                  "6. อัตราดอกเบี้ยที่แท้จริงเท่ากับอัตราร้อยละ"
                                }
                                value={form?.interest + "%"}
                              />
                            </div>
                          )}

                          <div className="border-b border-gray-300 mb-4"></div>

                          <Title title="ข้อมูลส่วนบุคคล" />
                          <SelectInput
                            label={"คำนำหน้านาม"}
                            value={{
                              label: form?.article,
                              value: form?.article,
                            }}
                            name="article"
                            onChangeSelect={onChangeSelect}
                            options={[
                              { label: "นาย", value: "นาย" },
                              { label: "นาง", value: "นาง" },
                              { label: "นางสาว", value: "นางสาว" },
                            ]}
                            width="w-28"
                          />
                          <TextInput
                            label={"ชื่อ"}
                            value={form.name}
                            name="name"
                            type="text"
                            onChange={onChangeForm}
                            width="w-36"
                            required
                          />
                          <TextInput
                            label={"นามสกุล"}
                            value={form.lastname}
                            name="lastname"
                            type="text"
                            onChange={onChangeForm}
                            width="w-36"
                            required
                          />
                          <TextInput
                            label={"ชื่อเล่น"}
                            value={form.nickname}
                            name="nickname"
                            type="text"
                            onChange={onChangeForm}
                            width="w-18"
                            required
                          />

                          <Content
                            title="บัตรประชาชน"
                            value={leasing_request?.citizenid}
                            onClickCheck={onClickCheck}
                            loadingCheck={loadingCheck}
                          />
                          {/* <TextInput
                            label={"บัตรประชาชน"}
                            value={form?.citizenid}
                            name="citizenid"
                            type="number"
                            onChange={onChangeForm}
                            width="w-18"
                            maxLength={13}
                          /> */}

                          <TextInput
                            label={"รหัสหลังบัตร"}
                            value={form?.hashCitizen}
                            name="hashCitizen"
                            type="text"
                            onChange={onChangeForm}
                            width="w-18"
                            // required
                            customenRequired={
                              ((form?.hashCitizen?.length > 0 &&
                                form?.hashCitizen?.length !== 14) ||
                                form?.hashCitizen?.length === 0) &&
                              checkClickSubmit
                            }
                            errorMessage={
                              form?.hashCitizen?.length > 0 &&
                              form?.hashCitizen?.length !== 14 &&
                              checkClickSubmit
                                ? "กรุณากรอกรหัสหลังบัตร"
                                : form?.hashCitizen?.length === 0 &&
                                  checkClickSubmit
                                ? "โปรดกรอกข้อมูล"
                                : ""
                            }
                          />

                          <DateInput
                            label={"วันหมดอายุบัตร"}
                            value={form?.citizenexpiredate}
                            name="citizenexpiredate"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required={
                              checkClickSubmit && !form?.citizenexpiredate
                            }
                          />

                          <SelectInput
                            label={"เพศ"}
                            value={{
                              label: form?.gender,
                              value: form?.gender,
                            }}
                            name="gender"
                            onChangeSelect={onChangeSelect}
                            options={[
                              { label: "ชาย", value: "ชาย" },
                              { label: "หญิง", value: "หญิง" },
                            ]}
                          />

                          <DateInput
                            label={"วัน/เดือน/ปี เกิด"}
                            value={form?.birthdateTh}
                            name="birthdateTh"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required
                          />

                          <Content
                            title="อายุ"
                            value={getAge("birthdateTh") || 0}
                          />

                          <SelectInput
                            label={"สถานภาพ"}
                            value={{
                              label: form?.marritalStatus,
                              value: form?.marritalStatus,
                            }}
                            name="marritalStatus"
                            onChangeSelect={onChangeSelect}
                            options={[
                              { label: "โสด", value: "โสด" },
                              { label: "สมรส", value: "สมรส" },
                              { label: "หย่าร้าง", value: "หย่าร้าง" },
                            ]}
                            width="w-24"
                          />

                          {form?.marritalStatus === "สมรส" && (
                            <React.Fragment>
                              <SelectInput
                                label={"คำนำหน้านาม"}
                                value={{
                                  label: form?.articlePartner,
                                  value: form?.articlePartner,
                                }}
                                name="articlePartner"
                                onChangeSelect={onChangeSelect}
                                options={[
                                  { label: "นาย", value: "นาย" },
                                  { label: "นาง", value: "นาง" },
                                  { label: "นางสาว", value: "นางสาว" },
                                ]}
                                width="w-28"
                                // required={
                                //   checkClickSubmit && !form?.articlePartner
                                // }
                                required
                              />
                              <TextInput
                                label={"ชื่อ (คู่สมรส)"}
                                value={form.namePartner}
                                name="namePartner"
                                type="text"
                                onChange={onChangeForm}
                                width="w-36"
                                required
                                // required={
                                //   checkClickSubmit && !form?.namePartner
                                // }
                              />
                              <TextInput
                                label={"นามสกุล (คู่สมรส)"}
                                value={form.lastnamePartner}
                                name="lastnamePartner"
                                type="text"
                                onChange={onChangeForm}
                                width="w-36"
                                required
                                // required={
                                //   checkClickSubmit && !form?.lastnamePartner
                                // }
                              />
                              <TextInput
                                label={"เบอร์โทรศัพท์ (คู่สมรส)"}
                                value={form.phoneNumberPartner}
                                name="phoneNumberPartner"
                                type="text"
                                onChange={onChangeForm}
                                width="w-36"
                                customenRequired={
                                  ((form?.phoneNumberPartner?.length > 0 &&
                                    form?.phoneNumberPartner?.length !== 10) ||
                                    !form?.phoneNumberPartner?.length) &&
                                  checkClickSubmit
                                }
                                errorMessage={
                                  (form?.phoneNumberPartner?.length > 0 &&
                                    form?.phoneNumberPartner?.length !== 10 &&
                                    checkClickSubmit &&
                                    "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก") ||
                                  (!form?.phoneNumberPartner?.length &&
                                    checkClickSubmit &&
                                    "โปรดกรอกข้อมูล")
                                }
                              />
                            </React.Fragment>
                          )}

                          <SelectInput
                            label={"จำนวนบุตร"}
                            value={{
                              label: form?.childern,
                              value: form?.childern,
                            }}
                            name="childern"
                            onChangeSelect={onChangeSelect}
                            options={[
                              { label: "จำนวนบุตร", value: "จำนวนบุตร" },
                              { label: "ไม่มีบุตร", value: "ไม่มีบุตร" },
                              { label: "1 คน", value: "1 คน" },
                              { label: "2-3 คน", value: "2-3 คน" },
                              { label: "3 คนขึ้นไป", value: "3 คนขึ้นไป" },
                            ]}
                            width="w-32"
                          />

                          <SelectInput
                            label={"การศึกษา"}
                            value={{
                              label: form?.education,
                              value: form?.education,
                            }}
                            name="education"
                            onChangeSelect={onChangeSelect}
                            options={[
                              {
                                label: "ม.3 หรือน้อยกว่า",
                                value: "ม.3 หรือน้อยกว่า",
                              },
                              { label: "ม.6 / ปวช.", value: "ม.6 / ปวช." },
                              { label: "ปวส.", value: "ปวส." },
                              { label: "ปริญญาตรี", value: "ปริญญาตรี" },
                              {
                                label: "สูงกว่าปริญญาตรี",
                                value: "สูงกว่าปริญญาตรี",
                              },
                            ]}
                            width="w-32"
                          />

                          <div className="mt-2 mb-2">
                            <Content
                              title="เบอร์โทรศัพท์"
                              value={leasing_request?.phone_number}
                            />
                          </div>

                          {/* <TextInput
                            label={"เบอร์โทรศัพท์"}
                            value={form.phone_number}
                            name="phone_number"
                            type="text"
                            onChange={onChangeForm}
                            width="w-36"
                          /> */}

                          <ExportContactBook
                            citizenid={leasing_request?.citizenid}
                          />

                          <TextInput
                            label={"อีเมล"}
                            value={form?.email}
                            name="email"
                            type="email"
                            onChange={onChangeForm}
                            width="w-42"
                            required
                          />

                          <TextInput
                            label={"ไลน์ไอดี"}
                            value={form?.lineid}
                            name="lineid"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                          />

                          <div className="mt-2">
                            <div className={"text-gray-700 mr-auto"}>
                              ที่อยู่ตามทะเบียนบ้าน :
                            </div>
                            <div className="flex flex-col">
                              <TextInput
                                label={"บ้านเลขที่"}
                                value={form?.addressCode}
                                name="addressCode"
                                type="text"
                                onChange={onChangeForm}
                                width="w-42"
                                required
                              />
                              <TextInput
                                label={"อาคาร/หมู่บ้าน/ซอย"}
                                value={form?.addressDesc}
                                name="addressDesc"
                                type="text"
                                onChange={onChangeForm}
                                width="w-56"
                                required
                              />
                              <SelectInput
                                label={"จังหวัด"}
                                value={{
                                  label: form?.addressProvince,
                                  value: form?.addressProvince,
                                }}
                                name="addressProvince"
                                onChangeSelect={onChangeSelect}
                                options={provinces.map((province) => {
                                  return {
                                    label: province,
                                    value: province,
                                  };
                                })}
                                width="w-40"
                              />
                              <SelectInput
                                label={"เขต"}
                                value={{
                                  label: form?.addressDistrict,
                                  value: form?.addressDistrict,
                                }}
                                name="addressDistrict"
                                onChangeSelect={onChangeSelect}
                                options={district.map((district) => {
                                  return {
                                    label: district,
                                    value: district,
                                  };
                                })}
                                width="w-40"
                                required
                              />
                              <SelectInput
                                label={"แขวง"}
                                value={{
                                  label: form?.addressSubDistrict,
                                  value: form?.addressSubDistrict,
                                }}
                                name="addressSubDistrict"
                                onChangeSelect={onChangeSelect}
                                options={subDistrict.map((district) => {
                                  return {
                                    label: district?.value,
                                    value: district?.value,
                                    ...district,
                                  };
                                })}
                                width="w-40"
                                required
                              />
                              <Content
                                title="รหัสไปรษณีย์"
                                value={form?.addressSubDistrictZipCode}
                              />
                            </div>
                          </div>

                          <div className="mt-2">
                            <div className={"text-gray-700 mr-auto"}>
                              ที่อยู่ปัจจุบัน :
                            </div>
                            <div className="flex flex-col">
                              <TextInput
                                label={"บ้านเลขที่"}
                                value={form?.officialAddressCode}
                                name="officialAddressCode"
                                type="text"
                                onChange={onChangeForm}
                                width="w-42"
                                required
                              />
                              <TextInput
                                label={"อาคาร/หมู่บ้าน/ซอย"}
                                value={form?.officialAddressDesc}
                                name="officialAddressDesc"
                                type="text"
                                onChange={onChangeForm}
                                width="w-56"
                                required
                              />
                              <SelectInput
                                label={"จังหวัด"}
                                value={{
                                  label: form?.currentAddressProvince,
                                  value: form?.currentAddressProvince,
                                }}
                                name="currentAddressProvince"
                                onChangeSelect={onChangeSelect}
                                options={provinces.map((province) => {
                                  return {
                                    label: province,
                                    value: province,
                                  };
                                })}
                                width="w-40"
                              />
                              <SelectInput
                                label={"เขต"}
                                value={{
                                  label: form?.currentAddressDistrict,
                                  value: form?.currentAddressDistrict,
                                }}
                                name="currentAddressDistrict"
                                onChangeSelect={onChangeSelect}
                                options={currentDistrict.map((district) => {
                                  return {
                                    label: district,
                                    value: district,
                                  };
                                })}
                                width="w-40"
                                required
                              />
                              <SelectInput
                                label={"แขวง"}
                                value={{
                                  label: form?.currentAddressSubDistrict,
                                  value: form?.currentAddressSubDistrict,
                                }}
                                name="currentAddressSubDistrict"
                                onChangeSelect={onChangeSelect}
                                options={currentSubDistrict.map((district) => {
                                  return {
                                    label: district?.value,
                                    value: district?.value,
                                    ...district,
                                  };
                                })}
                                width="w-40"
                                required
                              />
                              <Content
                                title="รหัสไปรษณีย์"
                                value={form?.currentAddressSubDistrictZipCode}
                              />
                            </div>
                          </div>

                          <div className="p-4 bg-gray-50">
                            <Content
                              title="พิกัด ณ ตอนยื่นกู้"
                              value={
                                leasing_request.latitude +
                                " , " +
                                leasing_request.longitude
                              }
                            />
                          </div>

                          {getCanEdit() && (
                            <button
                              disabled={loadingPersonalSave}
                              className={classNames(
                                " text-white px-2 py-1 rounded text-sm cursor-pointer ml-1 mt-1 mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed":
                                    loadingPersonalSave,
                                  "bg-green-500 cursor-pointer":
                                    !loadingPersonalSave,
                                }
                              )}
                              onClick={onClickSavePersonal}
                              // onClick={onClickAddDebt}
                            >
                              {loadingPersonalSave
                                ? "กำลังบันทึก..."
                                : "บันทึก"}
                            </button>
                          )}
                        </BoxContent>

                        <BoxContent>
                          <Title title="ข้อมูลการนัด" />
                          <Content
                            title="วันที่นัด"
                            value={
                              leasing_request?.appoint_date &&
                              leasing_request?.appoint_date !== "-"
                                ? format(
                                    new Date(leasing_request?.appoint_date),
                                    "dd/MM/yyyy"
                                  )
                                : ""
                            }
                          />
                          <Content
                            title="ระยะเวลา"
                            value={
                              leasing_request?.appoint_duration
                                ? `${leasing_request?.appoint_duration} นาที`
                                : ""
                            }
                          />
                          <Content
                            title="เวลาเริ่ม"
                            value={
                              leasing_request?.appoint_start_time
                                ? leasing_request?.appoint_start_time
                                : ""
                            }
                          />
                          <Content
                            title="เวลาสิ้นสุด"
                            value={
                              leasing_request?.appoint_end_time
                                ? leasing_request?.appoint_end_time
                                : ""
                            }
                          />
                          <Content
                            title="นัดโดย"
                            value={
                              leasing_request?.appoint_admin_name
                                ? leasing_request?.appoint_admin_name
                                : ""
                            }
                          />
                          <div className="border-b border-gray-300 mb-4"></div>

                          <Title title="ข้อมูลการทำงาน" />
                          <Content
                            title="latitude"
                            value={
                              leasing_request?.work_latitude
                                ? leasing_request?.work_latitude
                                : ""
                            }
                          />
                          <Content
                            title="longitude"
                            value={
                              leasing_request?.work_longitude
                                ? leasing_request?.work_longitude
                                : ""
                            }
                          />
                          <div>
                            {leasing_request?.work_longitude &&
                            leasing_request?.work_longitude ? (
                              <a
                                className="text-blue-500"
                                href={`https://www.google.co.th/maps/search/${leasing_request?.work_latitude},${leasing_request?.work_longitude}`}
                                target="_blank"
                              >
                                ตำแหน่ง
                              </a>
                            ) : (
                              <div>ตำแหน่ง</div>
                            )}
                          </div>

                          <div className="border-b border-gray-300 mb-4"></div>

                          <Title title="ข้อมูลรถ" />

                          <Content
                            title="ประเภท"
                            value={getType(leasing_request?.type)}
                          />

                          <Content
                            title="ยี่ห้อ"
                            value={leasing_request?.brand}
                          />

                          <Content
                            title="รุ่นยานพาหนะ"
                            value={leasing_request?.model}
                          />

                          <SelectInput
                            label={"ปีรถ"}
                            value={{
                              label: form?.year,
                              value: form?.year,
                            }}
                            name="year"
                            onChangeSelect={onChangeSelect}
                            options={yearOptions}
                            width="w-32"
                            required={checkClickSubmit && !form?.year}
                          />

                          {/* <TextInput
                            label={"ปีรถ"}
                            value={form?.year}
                            name="year"
                            type="text"
                            onChange={onChangeForm}
                            width="w-40"
                            required
                          /> */}

                          {/* <Content title="ปีรถ" value={leasing_request?.year} /> */}

                          <Content
                            title="เกียร์"
                            value={leasing_request?.gear}
                          />

                          {/* <Content
                            title="รุ่นย่อย"
                            value={leasing_request?.subModel}
                          /> */}

                          <TextInput
                            label={"รุ่นย่อย"}
                            value={form?.subModel}
                            name="subModel"
                            type="text"
                            onChange={onChangeForm}
                            width="w-80"
                            required={checkClickSubmit && !form?.subModel}
                          />

                          <TextInput
                            label={"ทะเบียนรถ"}
                            value={form?.plate}
                            name="plate"
                            type="text"
                            onChange={onChangeForm}
                            width="w-40"
                            // customenRequired={
                            //   form.loan_status === "นัดหมายแล้ว" && !form?.plate
                            // }
                            required={checkClickSubmit && !form?.plate}
                          />

                          <SelectInput
                            label={"ทะเบียนรถจังหวัด"}
                            value={{
                              label: form?.plate_province,
                              value: form?.plate_province,
                            }}
                            name="plate_province"
                            onChangeSelect={onChangeSelect}
                            options={provinces?.map((province) => {
                              return {
                                label: province,
                                value: province,
                              };
                            })}
                            width="w-40"
                            required={checkClickSubmit && !form?.plate_province}
                          />

                          <TextInput
                            label={"สีรถ"}
                            value={form?.color}
                            name="color"
                            type="text"
                            onChange={onChangeForm}
                            width="w-40"
                            // customenRequired={
                            //   form.loan_status === "นัดหมายแล้ว" && !form?.plate
                            // }
                            required={checkClickSubmit && !form?.color}
                          />

                          {/* <SelectInput
                            label={"ทะเบียนรถ (จังหวัด)"}
                            value={{
                              label: form?.plate_province,
                              value: form?.plate_province,
                            }}
                            name="plate_province"
                            onChangeSelect={onChangeSelect}
                            options={provinces.map((province) => {
                              return {
                                label: province,
                                value: province,
                              };
                            })}
                            width="w-40 mt-2"
                            required={checkClickSubmit && !form?.plate_province}
                          /> */}

                          <TextInput
                            label={"หมายเลขตัวถัง"}
                            value={form?.tankNumber}
                            name="tankNumber"
                            type="text"
                            onChange={onChangeForm}
                            width="w-40"
                            required={checkClickSubmit && !form?.tankNumber}
                          />
                          <DateInput
                            label={"วันที่ทะเบียนหมดอายุ"}
                            value={form?.registerExpireDate}
                            name="registerExpireDate"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required={
                              checkClickSubmit && !form?.registerExpireDate
                            }
                          />
                          <DateInput
                            label={"วันที่ประกันยานพาหนะหมดายุ"}
                            value={form?.insuranceExpireDate}
                            name="insuranceExpireDate"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required={
                              checkClickSubmit && !form?.insuranceExpireDate
                            }
                          />
                          <div className="flex items-center">
                            <TextInput
                              label={"ระยะทางที่ใช้"}
                              value={form?.distance}
                              name="distance"
                              type="text"
                              onChange={onChangeForm}
                              width="w-40"
                              required={checkClickSubmit && !form?.distance}
                            />
                            <div className="w-full text-left">กม.</div>
                          </div>

                          <TextInput
                            label={"หมายเลขเครื่อง"}
                            value={form?.serialNumber}
                            name="serialNumber"
                            type="text"
                            onChange={onChangeForm}
                            width="w-40"
                            required={checkClickSubmit && !form?.serialNumber}
                          />
                          <DateInput
                            label={"ปีที่จดทะเบียนรถ"}
                            value={form?.issueDate}
                            name="issueDate"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required={checkClickSubmit && !form?.issueDate}
                          />

                          {getCanEdit() && (
                            <button
                              disabled={loadingCar}
                              className={classNames(
                                " text-white px-2 py-1 rounded text-sm cursor-pointer ml-1 mt-1 mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed": loadingCar,
                                  "bg-green-500 cursor-pointer": !loadingCar,
                                }
                              )}
                              onClick={onClickSaveCar}
                              // onClick={onClickAddDebt}
                            >
                              {loadingCar ? "กำลังบันทึก..." : "บันทึก"}
                            </button>
                          )}

                          <div className="border-b border-gray-300 mb-4"></div>
                          <Title title="ข้อมูลการเงิน" />
                          <Content
                            title={"คงเหลือ"}
                            value={`${Number(
                              form?.income -
                                form?.burden -
                                form?.burdenSum -
                                getBurdenSum()
                            ).toLocaleString()} บาท`}
                            textColor="text-black"
                          />
                          <TextInput
                            label={"รายได้"}
                            value={form?.income}
                            name="income"
                            type="number"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.income}
                            className="text-green-600"
                          />
                          <TextInput
                            label={"รายจ่าย"}
                            value={form?.burden}
                            name="burden"
                            type="number"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.burden}
                            className="text-red-600"
                          />
                          <Content
                            title={"ยอดภาระหนี้สิน"}
                            value={`${Number(
                              form?.dataDebt.length > 0 ? getBurdenSum() : 0
                            ).toLocaleString()} บาท`}
                            textColor="text-orange-600"
                          />
                          {/* <TextInput
                            label={"ยอดภาระหนี้สิน"}
                            value={form?.burdenSum}
                            name="burdenSum"
                            type="number"
                            onChange={onChangeForm}
                            width="w-42"
                          /> */}

                          <div className="text-gray-700 flex items-center mt-2">
                            <div>ภาระหนี้สิน</div>
                            <button
                              className={classNames(
                                "bg-blue-500 text-white px-2 py-1 rounded text-xs cursor-pointer ml-1 mb-1"
                              )}
                              onClick={onClickAddDebt}
                            >
                              เพิ่ม
                            </button>
                          </div>
                          <Debt
                            debt={form?.dataDebt}
                            onChangeEditDebt={onChangeEditDebt}
                            onClickDeleteDebt={onClickDeleteDebt}
                          />

                          {getCanEdit() && (
                            <button
                              disabled={loadingDebtSave}
                              className={classNames(
                                " text-white px-2 py-1 rounded text-sm cursor-pointer ml-1 mt-1 mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed":
                                    loadingDebtSave,
                                  "bg-green-500 cursor-pointer":
                                    !loadingDebtSave,
                                }
                              )}
                              onClick={onClickSaveDebt}
                              // onClick={onClickAddDebt}
                            >
                              {loadingDebtSave ? "กำลังบันทึก..." : "บันทึก"}
                            </button>
                          )}

                          <div className="border-b border-gray-300 mb-4"></div>
                          <Title title="ข้อมูลการงาน" />
                          <SelectInput
                            label={"อาชีพ"}
                            value={{
                              label: form?.careertype,
                              value: form?.careertype,
                            }}
                            name="careertype"
                            onChangeSelect={onChangeSelect}
                            options={CAREER_OPTIONS?.map((option) => {
                              return {
                                label: option,
                                value: option,
                              };
                            })}
                            width="w-52"
                          />
                          <TextInput
                            label={"สถานประกอบการ"}
                            value={form?.company}
                            name="company"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.company}
                          />
                          <TextInput
                            label={"เบอร์โทรสถานประกอบการ"}
                            value={form?.job_phone}
                            name="job_phone"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.job_phone}
                          />
                          <TextInput
                            label={"ที่อยู่สถานประกอบการ"}
                            value={form?.job_address}
                            name="job_address"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.job_address}
                          />
                          <SelectInput
                            label={"ตำแหน่งล่าสุด"}
                            value={{
                              value: form?.jobposition,
                              label: form?.jobposition,
                            }}
                            options={POSITION_OPTIONS}
                            name="jobposition"
                            onChangeSelect={onChangeSelect}
                            width=" w-60"
                            required={checkClickSubmit && !form?.jobposition}
                          />

                          <DateInput
                            label={"วันที่เริ่มงาน"}
                            value={form?.beginjobdate}
                            name="beginjobdate"
                            onChange={onChangeFormDate}
                            width="w-18"
                            required={checkClickSubmit && !form?.beginjobdate}
                          />

                          <Content
                            title={"อายุงาน"}
                            value={`${getJobAge(
                              getAgeMonth(form?.beginjobdate)
                            )}`}
                            textColor="text-black"
                          />

                          <div className="mt-4">
                            {isTransfer ? (
                              <Content
                                title={"Remark"}
                                value={leasing_request?.remark || "-"}
                              />
                            ) : (
                              <React.Fragment>
                                <div>Remark</div>
                                <textarea
                                  name="remark"
                                  onChange={onChangeForm}
                                  value={form?.remark}
                                  type="text"
                                  rows={3}
                                  placeholder=""
                                  className="px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                                />
                                {getCanEdit() && (
                                  <button
                                    disabled={loadingRemark}
                                    onClick={onClickSaveRemark}
                                    className={classNames(
                                      "px-2 py-1 mt-2 rounded ",
                                      {
                                        "bg-green-500 cursor-pointer text-white":
                                          !loadingRemark,
                                        "bg-gray-400 cursor-not-allowed":
                                          loadingRemark,
                                      }
                                    )}
                                  >
                                    {loadingRemark
                                      ? "กำลังบันทึก..."
                                      : "บันทึก"}
                                  </button>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        </BoxContent>

                        <BoxContent>
                          <Title title="ไฟล์สัญญา" />

                          {/* <div className="flex flex-col">
                            <div className="flex items-center space-x-2">
                              {form?.ori_creditUri && (
                                <ContentFilePdf
                                  title="สัญญาเปิดเผยข้อมูลเครดิต"
                                  value={form?.creditUri}
                                />
                              )}
                              {!form?.ori_creditUri && (
                                <div>สัญญาเปิดเผยข้อมูลเครดิต</div>
                              )}
                              <UploadFile
                                name="creditUri"
                                onChange={onChangeFile}
                              />
                            </div>
                            <div className="flex items-center">
                              <div className=" text-blue-500">
                                {form?.creditUri?.name}
                              </div>
                            </div>
                          </div> */}

                          <div className="flex mt-1 flex-col">
                            <div className="flex items-center space-x-2">
                              {form?.ori_pdpaUri && (
                                <ContentFilePdf
                                  title="สัญญาPDPA"
                                  value={form?.pdpaUri}
                                />
                              )}
                              {!form?.ori_pdpaUri && <div>สัญญา</div>}
                              {/* <UploadFile
                                name="pdpaUri"
                                onChange={onChangeFile}
                              /> */}
                            </div>
                            <div className="flex items-center">
                              <div className=" text-blue-500">
                                {form?.pdpaUri?.name}
                              </div>
                            </div>
                          </div>

                          <div className="flex mt-2 flex-col">
                            {/* <div className="flex items-center space-x-2">
                              <div>ไฟล์ Statement</div>
                              <UploadFile
                                name="statementUris"
                                onChange={onChangeFile}
                                multiple
                              />
                            </div>
                            <div className="flex flex-col">
                              {form?.statementUris?.length > 0 &&
                                form?.statementUris?.map((document, index) => {
                                  return (
                                    <ContentFilePdf
                                      key={index}
                                      title={form?.ori_statementUris[index]}
                                      value={document?.value}
                                      display={document?.display}
                                    />
                                  );
                                })}
                            </div> */}

                            {/* <div className="flex flex-col">
                              {form?.statementDisplays?.length > 0 &&
                                form?.statementDisplays?.map(
                                  (document, index) => {
                                    return (
                                      <div key={index} className=" text-blue-500">
                                        {document?.name}
                                      </div>
                                    );
                                  }
                                )}
                            </div> */}
                          </div>

                          {form?.loan_status === "อนุมัติ" ||
                          form?.ori_fileBuro ? (
                            <div className="mt-2">
                              <ContentFilePdf
                                title="เอกสารเครดิตบูโร"
                                value={form.fileBuro}
                              />
                            </div>
                          ) : (
                            <div className="mt-2">
                              {form?.ori_fileBuro && (
                                <ContentFilePdf
                                  title="เอกสารเครดิตบูโร"
                                  value={form?.fileBuro}
                                />
                              )}
                              <div className="text-gray-700  text-base font-medium my-2">
                                เอกสารเครดิตบูโร
                              </div>
                              <input
                                name="fileBuro"
                                type="file"
                                onChange={onChangeFile}
                              />
                              <br />
                              {checkClickSubmit && !form.fileBuro && (
                                <span
                                  id="required_buro"
                                  className=" text-red-500"
                                >
                                  โปรดแนลไฟล์เอกสารเครดิตบูโร
                                </span>
                              )}
                            </div>
                          )}
                        </BoxContent>

                        <BoxContent>
                          <Title title="บุคคลอ้างอิงลำดับที่ 1" />

                          <TextInput
                            label={"ชื่อ"}
                            value={form.referalName}
                            name="referalName"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.referalName}
                          />
                          <TextInput
                            label={"เบอร์โทรศัพท์"}
                            value={form.referalPhone}
                            name="referalPhone"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            // required={checkClickSubmit && !form?.referalPhone}
                            maxLength={10}
                            customenRequired={
                              ((form?.referalPhone?.length > 0 &&
                                form?.referalPhone?.length !== 10) ||
                                !form?.referalPhone?.length) &&
                              checkClickSubmit
                            }
                            errorMessage={
                              (form?.referalPhone?.length > 0 &&
                                form?.referalPhone?.length !== 10 &&
                                checkClickSubmit &&
                                "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก") ||
                              (!form?.referalPhone?.length &&
                                checkClickSubmit &&
                                "โปรดกรอกข้อมูล")
                            }
                          />
                          <SelectInput
                            label={"ความสัมพันธ์"}
                            value={{
                              label: form?.relation,
                              value: form?.relation,
                            }}
                            name="relation"
                            onChangeSelect={onChangeSelect}
                            options={[
                              "หัวหน้างาน",
                              "เพื่อน",
                              "ญาติ",
                              "พ่อแม่",
                              "สามี-ภรรยา",
                              "ครู-อาจารย์",
                              "เพื่อนร่วมงาน",
                              "พี่-น้อง ร่วมบิดามารดาเดียวกัน",
                              "บุตรที่อายุมากกว่า 20 ปี",
                            ].map((relation) => {
                              return {
                                label: relation,
                                value: relation,
                              };
                            })}
                            required={checkClickSubmit && !form?.relation}
                            width="w-52"
                          />
                          <TextInput
                            label={"สถานที่ทำงานสำหรับบุคคลอ้างอิง"}
                            value={form.referalWork}
                            name="referalWork"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.referalWork}
                          />

                          {/* {form?.loan_status === "อนุมัติ" || isTransfer ? (
                            <React.Fragment>
                              <label class="inline-flex items-center">
                                <input
                                  disabled
                                  checked
                                  type="checkbox"
                                  class="form-checkbox"
                                />
                                <span class="ml-2">
                                  ยืนยันบุคคลอ้างอิงลำดับที่ 1
                                </span>
                              </label>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <label class="inline-flex items-center">
                                <input
                                  onChange={onChangeCheckBox}
                                  name="referal_one"
                                  type="checkbox"
                                  class="form-checkbox"
                                  defaultChecked={form.referal_one}
                                  value={form.referal_one}
                                />
                                <span class="ml-2">
                                  ยืนยันบุคคลอ้างอิงลำดับที่ 1
                                </span>
                              </label>
                              {status === "อนุมัติ" ||
                                (status === "รออนุมัติ" &&
                                  error &&
                                  !form.referal_one && (
                                    <div className=" text-red-500">
                                      โปรยืนยันบุคคลอ้างอิงลำดับที่ 1
                                    </div>
                                  ))}
                            </React.Fragment>
                          )} */}

                          <br />

                          {getCanEdit() && (
                            <button
                              disabled={loadingRelationOne}
                              className={classNames(
                                " text-white px-2 py-1 rounded text-sm cursor-pointer mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed":
                                    loadingRelationOne,
                                  "bg-green-500 cursor-pointer":
                                    !loadingRelationOne,
                                }
                              )}
                              onClick={() => onClickRelationSaveEdit("")}
                            >
                              {loadingRelationOne ? "กำลังบันทึก..." : "บันทึก"}
                            </button>
                          )}
                        </BoxContent>

                        <BoxContent>
                          <Title title="บุคคลอ้างอิงลำดับที่ 2" />
                          <TextInput
                            label={"ชื่อ"}
                            value={form.referalName2}
                            name="referalName2"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.referalName2}
                          />
                          <TextInput
                            label={"เบอร์โทรศัพท์"}
                            value={form.referalPhone2}
                            name="referalPhone2"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            // required
                            maxLength={10}
                            customenRequired={
                              ((form?.referalPhone2?.length > 0 &&
                                form?.referalPhone2?.length !== 10) ||
                                !form?.referalPhone2?.length) &&
                              checkClickSubmit
                            }
                            errorMessage={
                              (form?.referalPhone2?.length > 0 &&
                                form?.referalPhone2?.length !== 10 &&
                                checkClickSubmit &&
                                "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก") ||
                              (!form?.referalPhone2?.length &&
                                checkClickSubmit &&
                                "โปรดกรอกข้อมูล")
                            }
                          />
                          <SelectInput
                            label={"ความสัมพันธ์"}
                            value={{
                              label: form?.relation2,
                              value: form?.relation2,
                            }}
                            name="relation2"
                            onChangeSelect={onChangeSelect}
                            options={[
                              "หัวหน้างาน",
                              "เพื่อน",
                              "ญาติ",
                              "พ่อแม่",
                              "สามี-ภรรยา",
                              "ครู-อาจารย์",
                              "เพื่อนร่วมงาน",
                              "พี่-น้อง ร่วมบิดามารดาเดียวกัน",
                              "บุตรที่อายุมากกว่า 20 ปี",
                            ].map((relation) => {
                              return {
                                label: relation,
                                value: relation,
                              };
                            })}
                            required={checkClickSubmit && !form?.relation2}
                            width="w-52"
                          />
                          <TextInput
                            label={"สถานที่ทำงานสำหรับบุคคลอ้างอิง"}
                            value={form.referalWork2}
                            name="referalWork2"
                            type="text"
                            onChange={onChangeForm}
                            width="w-42"
                            required={checkClickSubmit && !form?.referalWork2}
                          />
                          {/* {leasing_request?.loan_status === "อนุมัติ" ||
                          isTransfer ? (
                            <React.Fragment>
                              <label class="inline-flex items-center">
                                <input
                                  disabled
                                  checked
                                  type="checkbox"
                                  class="form-checkbox"
                                />
                                <span class="ml-2">
                                  ยืนยันบุคคลอ้างอิงลำดับที่ 2
                                </span>
                              </label>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <label class="inline-flex items-center">
                                <input
                                  onChange={onChangeCheckBox}
                                  name="referal_two"
                                  type="checkbox"
                                  class="form-checkbox"
                                  defaultChecked={form.referal_two}
                                  value={form.referal_two}
                                />
                                <span class="ml-2">
                                  ยืนยันบุคคลอ้างอิงลำดับที่ 2
                                </span>
                              </label>
                              {status === "อนุมัติ" ||
                                (status === "รออนุมัติ" &&
                                  error &&
                                  !form.referal_two && (
                                    <div className=" text-red-500">
                                      โปรยืนยันบุคคลอ้างอิงลำดับที่ 2
                                    </div>
                                  ))}
                            </React.Fragment>
                          )} */}

                          <br />
                          {getCanEdit() && (
                            <button
                              disabled={loadingRelationTwo}
                              className={classNames(
                                " text-white px-2 py-1 mt-1 rounded text-sm cursor-pointer mb-1",
                                {
                                  "bg-gray-600 cursor-not-allowed":
                                    loadingRelationTwo,
                                  "bg-green-500 cursor-pointer":
                                    !loadingRelationTwo,
                                }
                              )}
                              onClick={() => onClickRelationSaveEdit("2")}
                            >
                              {loadingRelationTwo ? "กำลังบันทึก..." : "บันทึก"}
                            </button>
                          )}
                        </BoxContent>

                        {/* <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-4 gap-1"
                          }
                        >
                          <div className="text-center col-span-2">
                            <Title title="ภาพบัตรประจำตัวประชาชน/ข้าราชการ/ใบเปลี่ยนชื่อ" />
                            <Gallery
                              paths={tryParseJSON(leasing_request?.citizenUri)}
                              max="grid-cols-2 "
                            />
                          </div>
                          <div className="text-center">
                            <Title title={"ภาพถ่ายหน้าตรง"} />
                            <ContentImage value={leasing_request?.selfieUri} />
                          </div>
                          <div className="text-center">
                            <Title title={"ภาพสมุดบัญชี"} />
                            <ContentImage value={leasing_request?.bookbankUri} />
                          </div>
                        </BoxContent> */}

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-4 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4">
                            ภาพจากตอนสมัคร
                          </div>
                          <div className="text-center col-span-2">
                            <Title title="ภาพบัตรประจำตัวประชาชน/ข้าราชการ/ใบเปลี่ยนชื่อ" />
                            <Gallery
                              paths={tryParseJSON(leasing_request?.citizenUri)}
                              max="grid-cols-2 "
                            />
                          </div>
                          <div className="text-center">
                            <Title title={"ภาพถ่ายหน้าตรง"} />
                            <ContentImage value={leasing_request?.selfieUri} />
                          </div>
                          <div className="text-center">
                            <Title title={"ภาพสมุดบัญชี"} />
                            <ContentImage
                              value={leasing_request?.bookbankUri}
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            เอกสารทางการเงินของลูกค้า
                          </div>

                          <div className="text-center col-span-1">
                            <Title
                              title={"สลิปเงินเดือน/หนังสือรับรองเงินเดือน"}
                            />
                            {fcr?.fcr_slip_imgs?.map((slip, index) => {
                              return <ContentImage key={index} value={slip} />;
                            })}
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รายการเดินบัญชีที่รับเงินเดือน"} />
                            {fcr?.fcr_account_statement_imgs?.map(
                              (fcr_account_statement_img, index) => {
                                return (
                                  <ContentImage
                                    key={index}
                                    value={fcr_account_statement_img}
                                  />
                                );
                              }
                            )}
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title
                              title={"ภาพถ่ายสมุดบัญชีธนาคารที่ต้องการรับเงิน"}
                            />
                            {fcr?.fcr_bank_book_imgs?.map(
                              (fcr_bank_book_img, index) => {
                                return (
                                  <ContentImage
                                    key={index}
                                    value={fcr_bank_book_img}
                                  />
                                );
                              }
                            )}
                          </div>
                        </BoxContent>

                        {/* <BoxContent
                          className={"col-start-1 col-end-1 lg:col-end-4"}
                        >
                          <div className="text-center">
                            <Title title="แผนธุรกิจ" />
                            {JSON.parse(form?.businessContractUris)?.length >
                              0 && (
                              <Gallery
                                canRotate={true}
                                paths={tryParseJSON(
                                  leasing_request?.businessContractUris
                                )}
                              />
                            )}
                          </div>
                        </BoxContent> */}

                        {/* FCR */}
                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่ายยืนยันตัวตน FCR และลูกค้า
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่าย FCR และลูกค้า"} />
                            <ContentImage
                              value={
                                fcr?.fcr_comfirm_customer_imgs?.length > 0 &&
                                fcr?.fcr_comfirm_customer_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายขณะเซ็นสัญญา"} />
                            <ContentImage
                              value={
                                fcr?.fcr_comfirm_sign_imgs?.length > 0 &&
                                fcr?.fcr_comfirm_sign_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่ายรถ
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"หน้าตรง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_imgs?.length > 0 &&
                                fcr?.fcr_car_front_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"หลังตรง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_back_imgs?.length > 0 &&
                                fcr?.fcr_car_back_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"ซ้ายตรง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_left_imgs?.length > 0 &&
                                fcr?.fcr_car_left_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"ขวาตรง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_right_imgs?.length > 0 &&
                                fcr?.fcr_car_right_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"เปิดกระโปรงหน้า"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_hood_imgs?.length > 0 &&
                                fcr?.fcr_car_hood_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"เปิดกระโปรงหลัง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_back_skirt_imgs?.length > 0 &&
                                fcr?.fcr_car_back_skirt_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"คอนโซลหน้า"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_console_imgs?.length > 0 &&
                                fcr?.fcr_car_console_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"เบาะหลัง"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_back_seat_imgs?.length > 0 &&
                                fcr?.fcr_car_back_seat_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"เลขไมล์"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_mile_imgs?.length > 0 &&
                                fcr?.fcr_car_mile_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"เลขตัวถัง/เลขเครื่องยนต์ (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_tank_number_imgs?.length > 0 &&
                                fcr?.fcr_car_tank_number_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"เลขตัวถัง/เลขเครื่องยนต์ (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_tank_number_imgs?.length >= 1 &&
                                fcr?.fcr_car_tank_number_imgs[1]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"เลขตัวถัง/เลขเครื่องยนต์ (3)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_tank_number_imgs?.length >= 2 &&
                                fcr?.fcr_car_tank_number_imgs[2]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"รูปเล่มทะเบียนรถตัวจริง (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_book_imgs?.length > 0 &&
                                fcr?.fcr_car_book_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปเล่มทะเบียนรถตัวจริง (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_book_imgs?.length >= 1 &&
                                fcr?.fcr_car_book_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนปัจจุบัน (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_imgs?.length > 0 &&
                                fcr?.fcr_car_front_book_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนปัจจุบัน (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_imgs?.length >= 1 &&
                                fcr?.fcr_car_front_book_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนหน้า 16 (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_sixteen_imgs?.length >
                                  0 && fcr?.fcr_car_front_book_sixteen_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนหน้า 16 (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_sixteen_imgs?.length >=
                                  1 && fcr?.fcr_car_front_book_sixteen_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนหน้า 18 (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_eighteen_imgs?.length >
                                  0 && fcr?.fcr_car_front_book_eighteen_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายหน้าทะเบียนหน้า 18 (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_front_book_eighteen_imgs?.length >=
                                  1 && fcr?.fcr_car_front_book_eighteen_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"หน้ากรมธรรม์ประกันภัย (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_insurance_policy_imgs?.length >
                                  0 && fcr?.fcr_car_insurance_policy_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"หน้ากรมธรรม์ประกันภัย (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_insurance_policy_imgs?.length >=
                                  1 && fcr?.fcr_car_insurance_policy_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายป้ายวงกลม ภาษีประจำปี (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_tax_imgs?.length > 0 &&
                                fcr?.fcr_car_tax_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายป้ายวงกลม ภาษีประจำปี (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_tax_imgs?.length >= 1 &&
                                fcr?.fcr_car_tax_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"อื่นๆ"} />
                            <div
                              className={classNames("grid gap-2", {
                                "grid-cols-2":
                                  fcr?.fcr_car_other_imgs?.length > 1,
                                "grid-cols-1":
                                  fcr?.fcr_car_other_imgs?.length === 1,
                              })}
                            >
                              {fcr?.fcr_car_other_imgs?.length > 0 &&
                                fcr?.fcr_car_other_imgs.map(
                                  (fcr_car_other_img, index) => {
                                    return (
                                      <ContentImage
                                        key={index}
                                        value={fcr_car_other_img}
                                      />
                                    );
                                  }
                                )}
                            </div>
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"ใบรายงานตรวจสภาพรถ"} />
                            <ContentImage
                              value={
                                fcr?.fcr_car_inspection_report_imgs?.length >
                                  0 && fcr?.fcr_car_inspection_report_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่ายใบสมัครและชุดสัญญา
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"แบบคำขอสินเชื่อทะเบียนรถ"} />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_request_loan_imgs?.length >
                                  0 && fcr?.fcr_contact_request_loan_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title
                              title={"หนังสือยินยอมฯ ให้จำลองด้านเครดิต"}
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_consent_book_imgs?.length >
                                  0 && fcr?.fcr_contact_consent_book_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title
                              title={
                                "หนังสือให้ความยินยอมเปิดเผยข้อมูลส่วนบุคคล (PDPA)"
                              }
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_consent_book_pdpa_imgs
                                  ?.length > 0 &&
                                fcr?.fcr_contact_consent_book_pdpa_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"แบบคำขอโอนและรับโอน (โอนลอย)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_transfer_imgs?.length > 0 &&
                                fcr?.fcr_contact_transfer_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"หนังสือมอบอำนาจ"} />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_power_of_attorney_imgs
                                  ?.length > 0 &&
                                fcr?.fcr_contact_power_of_attorney_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"ใบโอนสิทธิประกันภัย"} />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_insurance_transfer_imgs
                                  ?.length > 0 &&
                                fcr?.fcr_contact_insurance_transfer_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title
                              title={
                                "สัญญากู้ยืมเงินสินเชื่อทะเบียนรถ (ลงนามและพยาน)"
                              }
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_car_registration_loan_imgs
                                  ?.length > 0 &&
                                fcr?.fcr_contact_car_registration_loan_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"บันทึกแนบท้าย"} />
                            <ContentImage
                              value={
                                fcr?.fcr_contact_save_end_imgs?.length > 0 &&
                                fcr?.fcr_contact_save_end_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"อื่นๆ"} />
                            <div
                              className={classNames("grid gap-2", {
                                "grid-cols-2":
                                  fcr?.fcr_contact_other_imgs?.length > 1,
                                "grid-cols-1":
                                  fcr?.fcr_contact_other_imgs?.length === 1,
                              })}
                            >
                              {fcr?.fcr_contact_other_imgs?.length > 0 &&
                                fcr?.fcr_contact_other_imgs.map(
                                  (fcr_contact_other_img, index) => {
                                    return (
                                      <ContentImage
                                        key={index}
                                        value={fcr_contact_other_img}
                                      />
                                    );
                                  }
                                )}
                            </div>
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่ายเอกสารส่วนตัว
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"สำเนา + บัตรประชาชนตัวจริง (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_id_card_imgs?.length > 0 &&
                                fcr?.fcr_personal_id_card_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"สำเนา + บัตรประชาชนตัวจริง (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_id_card_imgs?.length >= 1 &&
                                fcr?.fcr_personal_id_card_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"สำเนา + ทะเบียนบ้านตัวจริง (1)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_home_register_imgs?.length >
                                  0 && fcr?.fcr_personal_home_register_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"สำเนา + ทะเบียนบ้านตัวจริง (2)"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_home_register_imgs?.length >=
                                  1 && fcr?.fcr_personal_home_register_imgs[1]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"อื่นๆ"} />

                            <div
                              className={classNames("grid gap-2", {
                                "grid-cols-2":
                                  fcr?.fcr_personal_other_imgs?.length > 1,
                                "grid-cols-1":
                                  fcr?.fcr_personal_other_imgs?.length === 1,
                              })}
                            >
                              {fcr?.fcr_personal_other_imgs?.length > 0 &&
                                fcr?.fcr_personal_other_imgs.map(
                                  (fcr_personal_other_img, index) => {
                                    return (
                                      <ContentImage
                                        key={index}
                                        value={fcr_personal_other_img}
                                      />
                                    );
                                  }
                                )}
                            </div>
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-2 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title title={"แผนที่ตั้งที่อยู่ปัจจุบัน"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_current_address_imgs?.length >
                                  0 && fcr?.fcr_personal_current_address_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"รูปถ่ายบ้านตามที่อยู่ทะเบียนบ้าน"} />
                            <ContentImage
                              value={
                                fcr?.fcr_personal_home_address_imgs?.length >
                                  0 && fcr?.fcr_personal_home_address_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่ายเอกสารผู้ค้ำประกัน
                          </div>
                          <div className="text-center col-span-1">
                            <Title title={"สำเนาบัตรประชาชนผู้ค้ำ"} />
                            <ContentImage
                              value={
                                fcr?.fcr_guarantor_id_card_imgs?.length > 0 &&
                                fcr?.fcr_guarantor_id_card_imgs[0]
                              }
                            />
                          </div>
                          {/* <div className="text-center col-span-1">
                            <Title
                              title={
                                "สำเนาทะเบียนบ้านผู้ค้ำทะเบียนสมรส, ใบเปลี่ยนชื่อ-สกุล"
                              }
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_guarantor_home_imgs?.length > 0 &&
                                fcr?.fcr_guarantor_home_imgs[0]
                              }
                            />
                          </div>
                          <div className="text-center col-span-1">
                            <Title
                              title={"ภาพถ่ายบัตรประชาชนตัวจริงคู่สำเนาผู้ค้ำ"}
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_guarantor_id_card_real_imgs?.length >
                                  0 && fcr?.fcr_guarantor_id_card_real_imgs[0]
                              }
                            />
                          </div> */}
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title
                              title={
                                "สำเนาทะเบียนบ้านผู้ค้ำทะเบียนสมรส, ใบเปลี่ยนชื่อ-สกุล"
                              }
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_guarantor_home_imgs?.length > 0 &&
                                fcr?.fcr_guarantor_home_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-1 gap-1"
                          }
                        >
                          <div className="text-center col-span-1">
                            <Title
                              title={"ภาพถ่ายบัตรประชาชนตัวจริงคู่สำเนาผู้ค้ำ"}
                            />
                            <ContentImage
                              value={
                                fcr?.fcr_guarantor_id_card_real_imgs?.length >
                                  0 && fcr?.fcr_guarantor_id_card_real_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>

                        <BoxContent
                          className={
                            "col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-3 gap-1"
                          }
                        >
                          <div className="w-full text-center font-bold text-lg col-span-4 mb-4">
                            ภาพถ่าย Checklist
                          </div>
                          <div className="text-center col-span-1">
                            <ContentImage
                              value={
                                fcr?.fcr_personal_checklist_imgs?.length > 0 &&
                                fcr?.fcr_personal_checklist_imgs[0]
                              }
                            />
                          </div>
                        </BoxContent>
                      </div>
                    </div>
                  </div>

                  {/* แผงปุ่มด้านล่างสุด */}
                  <div className="bg-gray-50  my-1 text-center border-t border-gray-300  ">
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse   ">
                      <React.Fragment>
                        {/* {getCanEdit() &&
                          !["ไม่ผ่าน", "ยืนยัน", "อนุมัติ"].includes(
                            form?.loan_status
                          ) && (
                            <button
                              onClick={onClickSaveEdit}
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border text-white border-gray-300 shadow-sm px-4 py-2 bg-green-500 text-base font-medium  hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            >
                              บันทึกการแก้ไข
                            </button>
                          )} */}

                        {getButtonStatus().map((element, index) => {
                          return element;
                        })}
                        <button
                          onClick={() => {
                            setOpenModal(false);
                          }}
                          type="button"
                          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        >
                          Back
                        </button>
                      </React.Fragment>
                      {/* )} */}
                    </div>
                  </div>
                </div>
              )}
              {/* เนื้อหา */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default FootageRequestModal;
